<div class="ms-1 mt-3" *ngIf="!clientonboardBO.edit">
  <div class="row mb-2">
    <div class="col pl-0">
      <div widget class="card border-0 box-shadow ml-2">
        <div class="card-header transparent">
          <div class="col p-0">
            <label class="mt-1 fw-bold fs-4">Participant Agreement</label>
          </div>
        </div>
        <div class="card-body">
          <div class="row" *ngIf="global.LoginUserType != 'Onboard'">

            <div class="col-lg-10">
              <div class="row">
                <div class="col-lg-2">

                  <button class="btn btn-sm" [disabled]="global.viewTabs"
                    *ngIf="global.LoginUserType != 'Onboard' || fp.documentcreate" data-bs-toggle="modal"
                    data-bs-target="#templateModal"> Add Document </button>

                </div>
                <div class="col-lg-2">
                  <label class="mt-1"> Status</label>

                </div>
                <div class="col-lg-3">

                  <ng-select class="w" [items]="statuslist" [searchable]="true"
                    [(ngModel)]="getOnBoardList.documentStatus" [clearable]="true" bindLabel="lovName" bindValue="id"
                    (ngModelChange)="GetDocumentList()" [disabled]="global.viewTabs">
                  </ng-select>
                </div>
                <div class="col-lg-1">
                  <label class="mt-1">Completed</label>
                </div>
                <div class="col-lg-3">
                  <ng-select class="w" [items]="completedlist" [searchable]="true"
                    [(ngModel)]="getOnBoardList.completed" [clearable]="true" bindLabel="lovName" bindValue="id"
                    [disabled]="global.viewTabs" (ngModelChange)="GetDocumentList()">
                  </ng-select>
                </div>
              </div>
            </div>
            <div class="col-lg-2">
              <button class="btn btn-sm" [disabled]="global.viewTabs" (click)="Refresh()" [disabled]="global.viewTabs">
                Refresh</button>
            </div>

          </div>

        </div>

      </div>
    </div>
  </div>

  <!--================================== ClientDOCUMENT LIST  Ejs Grid================================================================-->
  <div class="ml-1 mt-3 " *ngIf="!clientonboardBO.edit && agencyid_boll">
    <div class="row">
      <div class="col pl-0">
        <div widget class="card border-0">
          <div class="card-body  widget-body pt-2">

            <nav *ngIf="global.OnboardType == 'EMPLOYEE' || global.OnboardType == 'CLIENT'">
              <div class="nav nav-tabs nav-fill" id="nav-tab" role="tablist">
                <a class="nav-item nav-link active" id="nav-unlocked-tab" data-bs-toggle="tab" href="#nav-unlocked"
                  role="tab" aria-controls="nav-unlocked" aria-selected="true" (click)="tabchange('TemplateDocument')"
                  [ngClass]="{
                      'mytab-inactive':
                      OnboardingSelectedTab != 'TemplateDocument',
                      active: OnboardingSelectedTab == 'TemplateDocument'
                    }">Onboarding Agreement
                </a>
                <a class="nav-item nav-link" id="nav-active-tab" data-bs-toggle="tab" href="#nav-active" role="tab"
                  aria-controls="nav-active-tab" aria-selected="false" (click)="tabchange('DynamiconboardDocument')"
                  [ngClass]="{
                      'mytab-inactive': OnboardingSelectedTab != 'DynamiconboardDocument',
                      active: OnboardingSelectedTab == 'DynamiconboardDocument'
                    }">Agency Agreement</a>

              </div>
            </nav>


            <div class="tab-content" id="nav-tabContent">

              <div class="tab-pane fade show active" id="nav-unlocked" role="tabpanel"
                aria-labelledby="nav-unlocked-tab" [ngClass]="{
                  active: OnboardingSelectedTab == 'TemplateDocument',
                  show: OnboardingSelectedTab == 'TemplateDocument'
                }">
                <!-- <ejs-grid #grid id='grid' [dataSource]='dataOnBoardclient | async' [allowResizing]='true'
                [allowSorting]='true' allowPaging='true' [allowFiltering]='true' [pageSettings]='initialPage'
                [filterSettings]='filterOptions' (dataStateChange)="datachangeonBoardEmp($event)"
                (actionBegin)="OnBoardActionComplete($event)" [allowPdfExport]='true'>
  
                <e-columns>
  
                  <e-column minWidth=100 headerText="Actions"  textAlign="center"
                    [showInColumnChooser]='false'>
                    <ng-template #template let-data>
                      <button class="btn me-2" title="view" (click)="editpage(data)" [disabled]="global.viewTabs"   *ngIf="fp.documentupdate"><i
                          class="fa fa-edit" ></i></button>
                      <button ejs-button title="Print" class="btn me-2" [disabled]="global.viewTabs"
                        (click)="GetonboardDetails(data)"> <i class="fa fa-print"></i></button>
                      <button class="btn me-2" title="Office notes" (click)="getOfficeNotes(data)"
                        *ngIf="global.OnboardingLoginType !='onboardLogin'" data-bs-toggle="modal"
                        data-bs-target="#modalofficeNotes" [disabled]="global.viewTabs"><i
                          class="fa fa-sticky-note-o"></i>
                      </button>
                      <button class="btn me-2" title="delete" data-bs-toggle="modal" data-bs-target="#modalDeleteClientAggrement" (click)="DeleteClientAggrement(data)" [disabled]="global.viewTabs"     *ngIf="global.OnboardingLoginType !='onboardLogin' && fp.documentdelete" ><i
                        class="fa fa-trash" ></i></button>
                    </ng-template>
                  </e-column>
  
                  <e-column minWidth=100 *ngIf="global.OnboardingLoginType !='onboardLogin'" field="officeNotes"
                    headerText="Office Notes" type='string'>
                    <ng-template #filterTemplate let-data>
                      <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
                    </ng-template>
                  </e-column>
  
                  <e-column minWidth=60 field="status" headerText="Onboard Status" type='string'>
                    <ng-template #filterTemplate let-data>
                      <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
                    </ng-template>
                  </e-column>
                  <e-column minWidth=100  field="isCompleted"  headerText="Is Completed?"  textAlign="center"
                    >
                    <ng-template #template let-data>
  
                      <button ejs-button class="border-0"  *ngIf="data.isCompleted ==false"
                              title="Not Completed"><i class="fa fa-times" style="font-size:30px; color:red;"></i></button>
                              <button ejs-button class="border-0"   *ngIf="data.isCompleted ==true"
                              title="Completed"><i class="fa fa-check" style="font-size:30px; color:green;"></i></button> 
  
                    </ng-template>
                  </e-column>
  
                </e-columns>
              </ejs-grid> -->

              </div>

              <div class="tab-pane fade" id="nav-active" role="tabpanel" aria-labelledby="nav-active-tab" [ngClass]="{
                  active: OnboardingSelectedTab == 'DynamiconboardDocument',
                  show: OnboardingSelectedTab == 'DynamiconboardDocument'
                }">

                <!-- <app-client-employee-dynamicform [DynamicFormRelation]="ClientEmployeeDynamicForm"
                  *ngIf="isdynamicFormcontact">
                </app-client-employee-dynamicform> -->


              </div>

            </div>



          </div>
        </div>
      </div>
    </div>
  </div>
</div>


<div *ngIf="!isdynamicFormcontact && !clientonboardBO.edit && agencyid_boll">
  <ejs-grid #grid id='grid' [dataSource]='dataOnBoardclient | async' [allowResizing]='true' [allowSorting]='true'
    allowPaging='true' [allowFiltering]='true' [pageSettings]='initialPage' [filterSettings]='filterOptions'
    (dataStateChange)="datachangeonBoardEmp($event)" (actionBegin)="OnBoardActionComplete($event)"
    [allowPdfExport]='true'>

    <e-columns>

      <e-column minWidth=100 headerText="Actions" textAlign="center" [showInColumnChooser]='false'>
        <ng-template #template let-data>
          <button class="btn me-2" title="view" (click)="editpage(data)" [disabled]="global.viewTabs"
            *ngIf="fp.documentupdate"><i class="fa fa-edit"></i></button>
          <button ejs-button title="Print" class="btn me-2" [disabled]="global.viewTabs"
            (click)="GetonboardDetails(data)"> <i class="fa fa-print"></i></button>
          <button class="btn me-2" title="Office notes" (click)="getOfficeNotes(data)"
            *ngIf="global.OnboardingLoginType !='onboardLogin'" data-bs-toggle="modal"
            data-bs-target="#modalofficeNotes" [disabled]="global.viewTabs"><i class="fa fa-sticky-note-o"></i>
          </button>
          <button class="btn me-2" title="delete" data-bs-toggle="modal" data-bs-target="#modalDeleteClientAggrement"
            (click)="DeleteClientAggrement(data)" [disabled]="global.viewTabs"
            *ngIf="global.OnboardingLoginType !='onboardLogin' && fp.documentdelete"><i
              class="fa fa-trash"></i></button>
        </ng-template>
      </e-column>

      <e-column minWidth=100 *ngIf="global.OnboardingLoginType !='onboardLogin'" field="officeNotes"
        headerText="Office Notes" type='string'>
        <ng-template #filterTemplate let-data>
          <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
        </ng-template>
      </e-column>

      <e-column minWidth=60 field="status" headerText="Onboard Status" type='string'>
        <ng-template #filterTemplate let-data>
          <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
        </ng-template>
      </e-column>
      <e-column minWidth=100 field="isCompleted" headerText="Is Completed?" [allowFiltering]="false" textAlign="center">
        <ng-template #template let-data>

          <button ejs-button class="border-0" *ngIf="data.isCompleted ==false" title="Not Completed"><i
              class="fa fa-times" style="font-size:30px; color:red;"></i></button>
          <button ejs-button class="border-0" *ngIf="data.isCompleted ==true" title="Completed"><i class="fa fa-check"
              style="font-size:30px; color:green;"></i></button>

        </ng-template>
      </e-column>

    </e-columns>
  </ejs-grid>
</div>

<app-client-employee-dynamicform class="card border-0" [DynamicFormRelation]="ClientEmployeeDynamicForm"
  *ngIf="isdynamicFormcontact">
</app-client-employee-dynamicform>


<!--slect Agency message-->
<div class="row mb-2" *ngIf="!agencyid_boll">
  <div class="col pl-0">
    <div widget class="card border-0 box-shadow">
      <div class="card-body pt-2">
        <div class="text-center text-danger pt-3">
          <label class="font-red " style="font-size: 13px;"><i class="fa fa-info-circle fa-lg mr-1"></i>&nbsp;Select
            agency to view details</label>
        </div>
      </div>
    </div>
  </div>
</div>


<!-- CLIENT DOCUMENT PAGE -->
<app-client-onboarding (dataEmitFromOnboard)="dataEmitFromOnboard($event)"
  *ngIf="clientonboardBO.edit && global.docbool" [clientonboardBO]="clientonboardBO"></app-client-onboarding>


<!-- //////////////////////////////// GET CLIENT DOCUMENT PDF //////////////////////////////////////// -->

<div style="position: absolute; left: -1156px; top: 500px;">
  <kendo-pdf-export #pdfClientOnboardinglist paperSize="A4" forcePageBreak=".page-break">
    <div style="width:730px;padding-left: 15px;">
      <div class="row mb-2">
        <div class="col pl-0">
          <div widget class="card border-0 box-shadow ">
            <div class="card-body  widget-body pb-0 pt-2 mb-4" *ngIf="clientProfile!=null">
              <div>

                <div class="row">
                  <div class="col-lg-12">
                    <label style="font-weight: bolder;color: #004290;font-size:15px;margin-top: 4px;"> Client Profile
                      Information
                    </label>
                    <hr style="margin-top: 0rem" />
                  </div>
                </div>

                <div class="row">
                  <div class="col-lg-6">
                    <div> <label class="font-weight ">First Name :</label>
                      {{clientProfile.firstName}}
                    </div>
                  </div>
                  <div class="col-lg-6">
                    <div> <label class="font-weight">Middle Name : </label>
                      {{clientProfile.middleName}}
                    </div>
                  </div>
                </div>
                <!-- Last Name : Gender:-->
                <div class="row">
                  <div class="col-lg-6">
                    <div> <label class="font-weight ">Last Name :</label>
                      {{clientProfile.lastName}}
                    </div>
                  </div>
                  <div class="col-lg-6">
                    <div> <label class="font-weight">Gender :</label>
                      {{clientProfile.gender_Name}}
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-lg-6">
                    <div> <label class="font-weight ">Date of Birth :</label>
                      {{clientProfile.dob |date: "MM/dd/yyyy"}}
                    </div>
                  </div>
                  <div class="col-lg-6">
                    <div> <label class="font-weight">Age :</label>
                      {{clientProfile.age}}
                    </div>
                  </div>
                </div>
                <!-- Phone Number : Date of Birth:-->
                <div class="row">
                  <div class="col-lg-6">
                    <div> <label class="font-weight ">Phone Number1 :</label>
                      {{clientProfile.phone1}}
                    </div>
                  </div>
                  <div class="col-lg-6">
                    <div> <label class="font-weight ">Phone Number2 :</label>
                      {{clientProfile.phone2}}
                    </div>
                  </div>
                </div>
                <!-- Email : UMPI:-->
                <div class="row">
                  <div class="col-lg-6">
                    <div> <label class="font-weight ">Email :</label>
                      {{clientProfile.email}}
                    </div>
                  </div>
                  <div class="col-lg-6">
                    <div> <label class="font-weight ">Street :</label>
                      {{clientProfile.street}}
                    </div>
                  </div>

                </div>
                <!-- Street :City: -->
                <div class="row">
                  <div class="col-lg-6">
                    <div> <label class="font-weight ">APT :</label>
                      {{clientProfile.apt}}
                    </div>
                  </div>
                  <div class="col-lg-6">
                    <div> <label class="font-weight">City :</label>
                      {{clientProfile.city}}
                    </div>
                  </div>
                </div>
                <!-- State Or Province :ZIP Code : -->
                <div class="row">
                  <div class="col-lg-6">
                    <div> <label class="font-weight ">State Or Province :</label>
                      {{clientProfile.state}}
                    </div>
                  </div>
                  <div class="col-lg-6">
                    <div> <label class="font-weight">County :</label>
                      {{clientProfile.county}}
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-lg-6">
                    <div> <label class="font-weight">ZIP Code :</label>
                      {{clientProfile.zipCode}}
                    </div>
                  </div>

                  <!-- <div class="col-lg-6">
                    <div> <label class="font-weight">PMI Number :</label>
                      {{clientProfile.pmiNumber}}
                    </div>
                  </div> -->
                </div>



                <!-------aka && apt-->
                <div class="row">
                  <div class="col-lg-6">
                    <div> <label class="font-weight">AKA :</label>
                      {{clientProfile.aka}}
                    </div>
                  </div>
                  <div class="col-lg-6">
                    <div> <label class="font-weight ">Weight :</label>
                      {{clientProfile.weight}}
                    </div>
                  </div>

                </div>

                <!---MedicID &&& Medicare-->
                <div class="row">
                  <div class="col-lg-6">
                    <div> <label class="font-weight">MedicaId :</label>
                      {{clientProfile.medicaid}}
                    </div>
                  </div>
                  <div class="col-lg-6">
                    <div> <label class="font-weight ">Medicare :</label>
                      {{clientProfile.medicare}}
                    </div>
                  </div>
                </div>

                <div class="row">
                  <!-- <div class="col-lg-6">
                      <div> <label class="font-weight">PClientId :</label>
                        {{clientProfile.pClientId}}
                      </div>
                    </div> -->
                  <!-- <div class="col-lg-6">
                    <div> <label class="font-weight">Internal Id :</label>
                      {{clientProfile.internalId}}
                    </div>
                  </div> -->
                  <!-- <div class="col-lg-6">
                    <div> <label class="font-weight ">Insurance No :</label>
                      {{clientProfile.insuranceNo}}
                    </div>
                  </div> -->
                </div>
                <div class="row">

                  <div class="col-lg-6">
                    <div> <label class="font-weight">SSN Number :</label>
                      {{clientProfile.ssn}}
                    </div>
                  </div>
                  <!-- <div class="col-lg-6">
                    <div> <label class="font-weight ">Type of WaiverName :</label>
                      {{clientProfile.typeofWaiverName}}
                    </div>
                  </div> -->
                </div>


                <!-- Driver's License :PCA Certificate #: -->
                <div class="row">

                  <!-- <div class="col-lg-6">
                    <div> <label class="font-weight">PCA Type # :</label>
                      {{clientProfile.pcaTypeName}}
                    </div>
                  </div> -->
                  <!-- <div class="col-lg-6">
                    <div> <label class="font-weight ">Assessment Rating :</label>
                      {{clientProfile.assessmentRatingName}}
                    </div>
                  </div> -->
                </div>

                <!-----PMI number && remarks-->
                <div class="row">

                  <!-- <div class="col-lg-6">
                    <div> <label class="font-weight ">Remarks:</label>
                      {{clientProfile.remarks}}
                    </div>
                  </div> -->
                  <div class="col-lg-6" *ngIf="clientProfile.clientSignatureName!=null">
                    <div> <label class="font-weight ">Client Signature Name :</label>
                      {{clientProfile.clientSignatureName}}
                    </div>
                  </div>
                  <div class="col-lg-6"
                    *ngIf="clientProfile.clientSignature!=null && clientProfile.clientSignature!=undefined && clientProfile.clientSignature!='' ">
                    <div>
                      <label>
                        Client Signature
                      </label>
                      <hr style="margin-top: 0rem" />
                      <div> <label class="font-weight "> <img
                            *ngIf="clientProfile.clientSignature!=''&& clientProfile.clientSignature!=null "
                            src={{clientProfile.clientSignature}} class="form-control mt-3 "
                            style="width: 179px;height:80px;" alt="employeeSign" width="48" height="48" /></label>

                      </div>
                    </div>
                  </div>
                </div>


                <!-- clientSignatureName & client Sign -->
                <!-- <div class="row">
                    <div class="col-lg-6" *ngIf="clientProfile.clientSignatureName!=null">
                      <div> <label class="font-weight ">clientSignatureName :</label>
                        {{clientProfile.clientSignatureName}}
                      </div>
                    </div>
                  
                  </div> -->
              </div>
            </div>

            <!-- Contacts -->
            <div class="card-body  widget-body pb-0 pt-2 mb-4">
              <div>
                <div class="row">
                  <div class="col-lg-12">
                    <label style="font-weight: bolder;color: #004290;font-size:15px;margin-top: 4px;">
                      Contact Information
                    </label>
                    <hr style="margin-top: 0rem" />
                  </div>
                </div>
                <ng-container *ngFor="let contactitem of clientContact;let a=index">
                  <div class="row ml-3">
                    <label class="font-weight "> Name :</label> &nbsp;&nbsp;&nbsp;{{contactitem.name}}
                  </div>
                  <div class="row  ml-3">
                    <label class="font-weight "> Contact Type :</label>
                    &nbsp;&nbsp;&nbsp;{{contactitem.contactTypeName}}
                  </div>
                  <div class="row  ml-3">
                    <label class="font-weight "> Relationship Type :</label>
                    &nbsp;&nbsp;&nbsp;{{contactitem.relationshipName}}
                  </div>
                  <div class="row  ml-3">
                    <label class="font-weight "> Phone Carrier Type :</label>
                    &nbsp;&nbsp;&nbsp;{{contactitem.phoneCarrierName}}
                  </div>
                  <div class="row  ml-3">
                    <label class="font-weight "> PhoneNumber :</label> &nbsp;&nbsp;&nbsp;{{contactitem.phoneNumber}}
                  </div>
                  <div class="row  ml-3">
                    <label class="font-weight "> Alernate PhoneNumber :</label>
                    &nbsp;&nbsp;&nbsp;{{contactitem.alternatePhoneNumber}}
                  </div>
                  <div class="row  ml-3">
                    <label class="font-weight "> Email :</label> &nbsp;&nbsp;&nbsp;{{contactitem.email}}
                  </div>
                  <div class="row  ml-3">
                    <label class="font-weight "> Fax :</label> &nbsp;&nbsp;&nbsp;{{contactitem.fax}}
                  </div>
                  <div class="row  ml-3">
                    <label class="font-weight "> Street :</label> &nbsp;&nbsp;&nbsp;{{contactitem.street}}
                  </div>
                  <div class="row  ml-3">
                    <label class="font-weight "> City :</label> &nbsp;&nbsp;&nbsp;{{contactitem.city}}
                  </div>
                  <div class="row  ml-3">
                    <label class="font-weight "> Zip Code :</label> &nbsp;&nbsp;&nbsp;{{contactitem.zipCode}}
                  </div>
                  <div class="row  ml-3">
                    <label class="font-weight "> State :</label> &nbsp;&nbsp;&nbsp;{{contactitem.state}}
                  </div>
                  <hr style="margin-top: 0rem" />
                </ng-container>
              </div>
            </div>

            <!-- Documents -->
            <div class="card-body widget-body pb-0 pt-2 mb-4">

              <div class="row mb-4">
                <div class="col">
                  <div class="card ">

                    <div class="card-body" style="padding:85px;">

                      <div class="row mt-4">
                        <h3><b>Participant Agreement</b></h3>
                      </div>

                      <div class="row mt-4">
                        <p>The participant is set-up as a household employer responsible for hiring and managing
                          employees. The employer can be the person receiving services or their representative. The
                          person who has authority to sign documents related to employer set-up is:</p>
                        <ul style="margin-left:30px">
                          <li>An adult participant</li>
                          <li>
                            A parent signing for a minor

                          </li>
                          <li>A guardian (a copy of the guardian paperwork must be provided)</li>
                        </ul>
                      </div>
                      <div class="row mt-2">
                        {{this.global.agencyName}} is a Financial Management Service (FMS) enrolled with the Department
                        of Human
                        Services (DHS) as a MN Health Care Provider. {{this.global.agencyName}} FMS acts as a
                        Fiscal/Employer Agent
                        under {{OnboardClientDocumentBO?.participantAgreementDocumentBO?.fmsAct}} and is responsible for
                        enrolling employees; processing
                        timesheets, invoices, and reimbursements; tax filing; billing and program reporting.
                      </div>
                      <div class="row mt-2">
                        The agreement takes effect after intake completion and renews on the next plan’s start date or
                        date of that plan’s lead agency signature, whichever is later. To avoid service gaps, plans
                        should
                        be submitted to the lead agency 30 days prior to the current plan’s expiration.
                      </div>
                      <div class="row mt-2">
                        Services start when {{this.global.agencyName}} FMS:
                      </div>
                      <ul style="margin-left:30px">
                        <li>receives a service authorization and plan from the lead agency
                        </li>
                        <li>an employer is set up with Workers’ Compensation if needed and</li>
                        <li>enrolled employees have successfully completed a background check</li>
                      </ul>

                      <div class="row mt-2">
                        <p>Fees are charged according to DHS published rates. In addition, there are employer taxes and
                          benefits billed to the budget based on the employer’s experience and the age and relationship
                          of the employee to the employer. {{this.global.agencyName}} FMS fees are
                          <label>{{OnboardClientDocumentBO?.participantAgreementDocumentBO?.cdcsBudgetwithStaffing}}</label>
                          <!-- <input type="text" class="form-control mb-2" [(ngModel)]="OnboardClientDocumentBO?.participantAgreementDocumentBO.fees"
                              style="width: 100px;display: inline-block;"> -->
                          &nbsp;/month for a CDCS budget with
                          staffing;
                          <label>{{OnboardClientDocumentBO?.participantAgreementDocumentBO?.cdcsBudgetwithGoods}}</label>
                          <!-- <input type="text" class="form-control mb-2" [(ngModel)]="OnboardClientDocumentBO?.participantAgreementDocumentBO.cdcs"
                              style="width: 100px;display: inline-block;">  -->
                          &nbsp;/month for a CDCS budget with goods only; and
                          <label>{{OnboardClientDocumentBO?.participantAgreementDocumentBO?.csgBudget}}</label>
                          <!-- <input type="text" class="form-control mb-2"  [(ngModel)]="OnboardClientDocumentBO?.participantAgreementDocumentBO.csg"
                              style="width: 100px;display: inline-block;"> -->
                          &nbsp;/month for a CSG budget.
                        </p>
                      </div>
                      <div class="row mt-2">
                        <h3><b>{{this.global.agencyName}} FMS Roles and Responsibilities </b></h3>
                      </div>
                      <div class="row mt-2">
                        Acts as third-party designee and obtains an Employer Identification Number (EIN) for the
                        participant with completion and filing of IRS Form SS-4.



                      </div>
                      <div class="row mt-2">
                        Assists with completion and filing of IRS Form 2678 appointing {{this.global.agencyName}} FMS as
                        the agent
                        responsible for filing federal taxes for the employer. {{this.global.agencyName}} FMS is
                        responsible for tax
                      </div>
                      <div class="row mt-2">
                        obligations from the service start until approval of agent status is received.
                        Obtains a MN Tax ID for the employer with completion and filing of the Application for Business
                        Registration.
                      </div>
                      <div class="row mt-2">
                        Assists in the completion and filing of MN Rev 184 which appoints {{this.global.agencyName}} FMS
                        limited power
                        of attorney for the purpose of state withholding tax.
                      </div>
                      <div class="row mt-2">
                        Acts as the employer’s Unemployment Insurance (UI) agent, establishes an account when
                        needed, represents the employer in UI matters and receives related mailings.



                      </div>
                      <div class="row mt-2">
                        Obtains a Workers’ Compensation policy for the employer if needed. If the employer has their
                        own policy, a copy must be provided before employees start work and when the policy renews.
                      </div>
                      <div class="row mt-2">
                        Maintains and processes employee applications including background checks, fingerprint
                        authorizations, Unique MN Provider Identifier applications, W-4s, I-9s, pay notices and
                        relationship disclosures.
                      </div>
                      <div class="row mt-2">
                        Reports new hires to MN for child support obligations, processes worker garnishments in
                        accordance with federal and state laws and deducts union dues if required.
                      </div>
                      <div class="row mt-2">
                        Provides Employer and Employee Handbooks that include information on federal and state
                        laws, resources, and policies for Mandated Reporting, Fraud and HIPAA.



                      </div>
                      <div class="row mt-2">
                        Makes payment authorized in the plan in accordance with approved time entries and federal
                        and state labor laws such as the Fair Labor Standards Act.
                      </div>
                      <div class="row mt-2">
                        Calculates and deposits employer and employee payroll taxes, issues W-2s and refunds over
                        collected FICA.
                      </div>
                      <div class="row mt-2">
                        Provide vendor packets with W-9s, pays service vendors and issues 1099s.
                      </div>
                      <div class="row mt-2">
                        Assists with orders and processes reimbursements Friday if the request is received Tuesday.


                      </div>
                      <div class="row mt-2">
                        Sets up a budget based on the participant’s approved plan and tracks changes.
                      </div>
                      <div class="row mt-2">
                        Makes monthly reports available showing budgeted and spent funds and reports overspending
                        (>15%), underspending (>15%) and unapproved overtime. </div>
                      <div class="row mt-2">

                        Verifies program eligibility, suspends payment if eligibility has lapsed, and bills for
                        services.
                      </div>
                      <div class="row mt-4">
                        <h3><b>Participant/Representative Roles and Responsibilities</b></h3>
                      </div>
                      <div class="row mt-2">
                        The employer recruits, hires, trains, supervises, and terminates employees.



                      </div>
                      <div class="row mt-2">
                        Employees cannot be scheduled before {{this.global.agencyName}} FMS has notified the employer an
                        employee
                        can start. If an employee works before their start date, they will not be paid by
                        {{this.global.agencyName}} FMS.
                      </div>
                      <div class="row mt-2">
                        The employer will not discriminate against employees or applicants because of race, religion,
                        national origin, sex (including pregnancy, sexual orientation, or gender identification),
                        disability,
                        age or any other status protected by law.
                      </div>
                      <div class="row mt-2">
                        The employer maintains employee files with job descriptions, evaluations and records of
                        tardiness, absenteeism, or termination if needed. The employer notifies
                        {{this.global.agencyName}} if an
                        employee is ineligible for unemployment with documentation of employee performance.
                      </div>
                      <div class="row mt-2">
                        The employer determines employee pay rates and benefits in compliance with program rules,
                        the collective bargaining agreement, and local ordinances. Wage changes are communicated to


                      </div>
                      <div class="row mt-2">
                        {{this.global.agencyName}} FMS in writing, in addition to being listed in the plan.
                        Parents of minors and spouses are unable to work over 40 hours a week. Hours above 40 hours
                        are considered unpaid natural supports.
                      </div>
                      <div class="row mt-2">
                        If minors, 14 to 17 years old, are employed, minor labor laws must be followed.

                      </div>
                      <div class="row mt-2">
                        Overtime is unapproved unless documented by the lead agency. Overtime occurs when an
                        employee works more than 40 hours a week. If submitted, it is paid at 1.5 times the rate of pay.
                      </div>
                      <div class="row mt-2">
                        The employer and employee submit time and are responsible for the accuracy of the hours. Pay
                        dates are listed in the Payroll Calendar. Pay statements are available through CYMA. Hours



                      </div>
                      <div class="row mt-2">
                        worked should be submitted by deadlines and no later than 30 days from the service date.
                        The participant understands employees are mandated reporters under the Vulnerable Adult
                        and Maltreatment of Minors Reporting Act. {{this.global.agencyName}} staff are also mandated
                        reporters.
                      </div>
                      <div class="row mt-2">
                        The participant will report fraud to {{this.global.agencyName}}, the lead agency or DHS.
                      </div>
                      <div class="row mt-2">
                        The participant will notify {{this.global.agencyName}} of admission to a care facility such as a
                        hospital, group
                        home, assisted living or nursing home. Employees cannot work during this time.
                      </div>
                      <div class="row mt-2">
                        Participants with a patient responsibility must pay their spenddown or responsibility by the
                        listed date. If patient responsibilities are not met, services may be suspended.



                      </div>
                      <div class="row mt-2">
                        The participant completes necessary paperwork to maintain program eligibility.
                      </div>
                      <div class="row mt-2">
                        The participant reviews spending reports to make sure information is accurate and adjusts
                        spending if the budget is overspent.
                      </div>
                      <div class="row mt-2">
                        The participant pays for goods, services or hours worked beyond budgeted funds.
                      </div>
                      <div class="row mt-4">
                        <h3><b>Customer Service and Grievances</b></h3>
                      </div>
                      <div class="row mt-2">
                        {{this.global.agencyName}} strives to return calls and emails within a business day and provide
                        responsive and
                        respectful customer service. Grievances can be submitted online, by email or mail in the event
                        there is an issue, and it is not resolved through communication with the
                        {{this.global.agencyName}} FMS
                        Coordinator. Grievances are investigated and resolved within 30 days. If the issue cannot be
                        resolved within 30 days, the reason for the delay will be explained in writing
                      </div>
                      <div class="row mt-4">
                        <h3><b>Termination</b></h3>
                      </div>
                      <div class="row mt-2">
                        Either party may terminate this agreement. Once terminated, {{this.global.agencyName}} FMS will
                        revoke any
                        agent appointments and close out Workers’ Compensation if obtained by {{this.global.agencyName}}
                        FMS. When
                        transferring to a different FMS provider, {{this.global.agencyName}} FMS will work with the new
                        provider to
                        coordinate necessary information for tax filings and continuity of care.
                      </div>
                      <div class="row mt-2">
                        <h3><b>{{this.global.agencyName}} Terminates FMS</b></h3>
                      </div>

                      <div class="row mt-2">
                        {{this.global.agencyName}} FMS will provide written notice to the participant at least 10 days
                        before the
                        proposed service termination date unless DHS grants an exception. Exceptions include:
                        <ul style="margin-left:30px">
                          <li>A hostile relationship characterized by lack of collaboration and
                            communication.

                          </li>
                          <li>Conduct resulting in a report being made to the Office of Inspector General
                            (OIG) or the Surveillance & Integrity Review Section (SIRS).</li>
                        </ul>

                      </div>
                      <div class="row mt-2">
                        {{this.global.agencyName}} FMS must send written notice to the participant and lead agency. The
                        notice will
                        include the effective date and reason for termination.

                      </div>
                      <div class="row mt-2">
                        {{this.global.agencyName}} FMS can terminate services without cause, if the participant is given
                        written notice
                        at
                        the payment of a quarter end and at least 30 days before termination.
                      </div>
                      <div class="row mt-2">
                        <h3><b>Participant Terminates FMS</b></h3>
                      </div>
                      <div class="row mt-2">
                        When a Participant initiates a request to terminate services, {{this.global.agencyName}} FMS
                        will respond with
                        written acknowledgement within 5 business days. The acknowledgement will include the date
                        the request was received, the requested termination date and the actual termination date
                        services will occur if the requested date cannot be accommodated.
                      </div>
                      <div class="row mt-4">
                        <h3><b>Agent Authorization</b></h3>
                      </div>
                      <div class="row mt-2">
                        {{this.global.agencyName}} FMS is authorized:
                        <ul style="margin-left:30px">
                          <li>To act as third-party designee for IRS Form SS-4 and obtain an EIN.


                          </li>
                          <li>To file Forms 2678 and Rev 184 for employer tax reporting.</li>
                          <li>To act as Unemployment Agent: apply for an account, fulfill employer
                            responsibilities (tax, benefits and appeals) and receive related documents.</li>
                          <li>To obtain Workers’ Compensation if a policy is needed. </li>

                        </ul>
                      </div>
                      <div class="row mt-2">
                        The authorization remains in effect until {{this.global.agencyName}} no longer acts as
                        Fiscal/Employer Agent.
                      </div>
                      <div class="row mt-4">
                        <h3><b>Signatures and Effective Date </b></h3>
                      </div>
                      <div class="row mt-2">
                        This Agreement is effective&nbsp;
                        <label>{{OnboardClientDocumentBO?.participantAgreementDocumentBO?.effectivedate}}</label>
                        <!-- <my-date-picker  style="width:120px;display: inline-block;"
                              [options]="myDatePickerOptionsDOB" [selDate]="OnboardClientDocumentBO?.participantAgreementDocumentBO.effective_Date" placeholder="mm/dd/yyyy"
                             >
                            </my-date-picker> -->
                        &nbsp;
                        (date) between {{this.global.agencyName}} FMS and the participant
                        employer and/or their representative&nbsp;
                        <label>{{OnboardClientDocumentBO?.participantAgreementDocumentBO?.clientName}}</label>
                        <!-- <input type="text" [(ngModel)]="OnboardClientDocumentBO?.participantAgreementDocumentBO.best_Care_FMS_and_the_participant_employer"
                              class="form-control" style="width:120px;display: inline-block;"> -->
                        (print name). By signing, the
                        parties agree to the terms within; have reviewed and understand roles and responsibilities; and
                        a Handbook has been provided with Mandated Reporting, HIPAA, Fraud and Grievance Policies.
                      </div>


                      <div class="row mt-4">
                        <div class="col-6">
                          <button type="button" class="btn btn-primary" data-bs-toggle="modal" [disabled]="true"
                            data-bs-target="#Participant2">
                            Participant/Representative Signature:
                          </button> <sup class="super-script">&nbsp;*&nbsp;</sup>
                        </div>
                        <div class="col-lg-1">
                          <label for="cname">Date: <sup class="super-script">&nbsp;*&nbsp;</sup></label>
                        </div>
                        <div class="col-lg-3">
                          <label>{{OnboardClientDocumentBO?.participantAgreementDocumentBO?.participantSign2Date}}</label>
                          <!-- <my-date-picker  class="w-100" [options]="myDatePickerOptionsDOB"
                                [selDate]="OnboardClientDocumentBO?.participantAgreementDocumentBO.date" placeholder="mm/dd/yyyy"
                               >
        
                              </my-date-picker> -->
                        </div>
                      </div>
                      <div class="row mt-2 mb-2">

                        <div> <label class="font-weight "> <img
                              *ngIf="OnboardClientDocumentBO?.participantAgreementDocumentBO.pantsign!=''&& OnboardClientDocumentBO?.participantAgreementDocumentBO.pantsign!=null "
                              src={{OnboardClientDocumentBO?.participantAgreementDocumentBO.pantsign}}
                              class="form-control mt-3 " style="width: 179px;height:80px;" alt="employeeSign" width="48"
                              height="48" /></label>

                        </div>

                      </div>
                      <div class="row mt-2">

                      </div>


                    </div>
                    <div class="card-footer">
                      <div class="row">

                        <!-- <div class="col text-right mb-3 mt-3">
                            
                            <button type="button"  class="btn blue-btn mr-3"  (click)="save()"  [disabled]="OnboardClientDocumentBO?.participantAgreementDocumentBO.date==''||OnboardClientDocumentBO?.participantAgreementDocumentBO.date==undefined||OnboardClientDocumentBO?.participantAgreementDocumentBO.date==null || pantsign==null || pantsign==''||pantsign==undefined" class="btn blue-btn"
                             >Save</button>
                            <button type="button" class="btn blue-btn" *ngIf="isUpdate && !clientonboardBO.edit">Update
                            
                            </button>
                            <button type="button" class="btn blue-btn ml-3" data-bs-dismiss="modal">Clear</button>
                          </div> -->

                      </div>
                    </div>

                  </div>
                </div>
              </div>


              <div class="row mb-4 mt-4">
                <div class="col">
                  <div class="card ">
                    <div class="card-body" style="padding:85px;">

                      <div class="row mt-3">
                        <h3><b>Release of Information
                          </b></h3>
                      </div>
                      <div class="row mt-4">
                        <div class="col-lg-2">
                          <div class="row">
                            <label>Participant Name</label>
                          </div>

                        </div>
                        <div class="col-lg-8">
                          <!-- <input type="text" class="form-control" [(ngModel)]="OnboardClientDocumentBO?.release_of_InformationDocumentBO.participantName"> -->
                          <label>{{OnboardClientDocumentBO?.release_of_InformationDocumentBO.participantName}}</label>
                        </div>
                      </div>
                      <div class="row mt-3">
                        <p>I authorize the release of my records /information between {{this.global.agencyName}} and the
                          following</p>
                        <ul style="margin-left:30px">
                          <li>Lead agency</li>
                          <li>Support planner</li>
                          <li>Plan vendors</li>
                          <li>FMS (if transferring from an FMS to obtain employer IDs, accounts and
                            spending reports to coordinate tax filing and program delivery)</li>
                          <li>
                            Other&nbsp;
                            <!-- <input type="text" class="form-control mb-2" [(ngModel)]="OnboardClientDocumentBO?.release_of_InformationDocumentBO.other"
                                  style="width: 300px;display: inline-block;"> &nbsp; -->
                            <label>{{OnboardClientDocumentBO?.release_of_InformationDocumentBO.others}}</label>
                          </li>
                        </ul>
                      </div>



                      <div class="row mt-1">
                        <div class="col-lg-10 col-md-6 col-sm-12 col-xs-12 aligned_form">
                          <label class="col-lg-6">I authorize {{this.global.agencyName}} to send unsecured communication
                            containing protected
                            health
                            information (PHI) by email:</label>

                          <div class="col-lg-2">
                            <label>yes</label>
                            <input type="radio" value="true" id="pre5" name="select"
                              [(ngModel)]="OnboardClientDocumentBO.release_of_InformationDocumentBO.authorizeBestCare">
                          </div>
                          <div class="col-lg-2">
                            <label>no</label>
                            <input type="radio" value="false" id="pre6" name="select"
                              [(ngModel)]="OnboardClientDocumentBO.release_of_InformationDocumentBO.authorizeBestCare">

                          </div>


                          <!-- <div class="ml-2" *ngFor="let i of staffingList">
                            <input type="radio" value="true" name="select8" id="pre3" 
                            [(ngModel)]="OnboardClientDocumentBO.release_of_InformationDocumentBO.authorizeBestCare">


                          </div>  -->
                        </div>


                        <!-- <input type="radio" [value]="i.Key"
                                  [(ngModel)]="OnboardClientDocumentBO?.release_of_InformationDocumentBO.authorize_Best_Care_send_unsecured_communication_information_PHI_email"
                                  name="radio" />
                                {{i.Value}} -->
                        <!-- <label>{{OnboardClientDocumentBO?.release_of_InformationDocumentBO.authorizeBestCare}}</label> -->

                      </div>

                      <div class="row mt-2">
                        I have been informed of the risks of transmitting PHI by unsecured means which include:
                        <ul style="margin-left:30px;">
                          <li>Email that includes PHI will not be encrypted.</li>
                          <li>Unsecured email may not prevent others from accessing content.</li>
                          <li>Sending unsecured PHI exposes it to others who may use it maliciously.</li>
                          <li>{{this.global.agencyName}} has no control over email access sent unsecured from our
                            server.</li>

                        </ul>
                      </div>
                      <div class="row mt-2">
                        The authorization is valid for one year from the signature date unless specified. I may end the
                        authorization by written request any time by contacting the {{this.global.agencyName}} FMS.
                      </div>
                      <div class="row mt-4">
                        <div class="col-6">
                          <button type="button" class="btn btn-primary" data-bs-toggle="modal"
                            data-bs-target="#Participant3">
                            Signature:
                          </button> <sup class="super-script">&nbsp;*&nbsp;</sup>
                        </div>
                        <div class="col-lg-1">
                          <label for="cname">Date:<sup class="super-script">&nbsp;*&nbsp;</sup></label>
                        </div>
                        <div class="col-lg-3">
                          <label>{{OnboardClientDocumentBO?.release_of_InformationDocumentBO.signDate}}</label>

                        </div>
                      </div>
                      <div class="row mt-2 mb-2">
                        <div> <label class="font-weight "> <img *ngIf="pantsign1!=''&& pantsign1!=null "
                              src={{pantsign1}} class="form-control mt-3 " style="width: 179px;height:80px;"
                              alt="employeeSign" width="48" height="48" /></label>

                        </div>
                      </div>


                    </div>
                    <div class="card-footer">
                      <div class="row">

                        <!-- <div class="col text-right mb-3 mt-3">
                              
                              <button type="button"  class="btn blue-btn mr-3"   (click)="save()"  class="btn blue-btn"
                              [disabled]="OnboardClientDocumentBO?.release_of_InformationDocumentBO.date==''||OnboardClientDocumentBO?.release_of_InformationDocumentBO.date==undefined||OnboardClientDocumentBO?.release_of_InformationDocumentBO.date==null || pantsign1==null || pantsign1==''||pantsign1==undefined" >Save</button>
                              <button type="button" class="btn blue-btn" *ngIf="isUpdate && !clientonboardBO.edit">Update
                              
                              </button>
                              <button type="button" class="btn blue-btn ml-3" data-bs-dismiss="modal">Clear</button>
                            </div> -->

                      </div>
                    </div>

                  </div>
                </div>
              </div>


              <div class="row mb-4 mt-4">
                <div class="col">
                  <div class="card ">
                    <div class="card-body" style="padding:65px;">

                      <div class="row">
                        <div class="col-lg-2">
                          <h5>Form<h3><b>SS-4</b></h3>
                          </h5>
                          <p>(Rev. December 2023)</p>
                          <p>Department of the Treasury
                            Internal Revenue Service </p>
                        </div>
                        <div class="col-lg-6">
                          <div class="row">
                            <div class="col-lg-12">
                              <h4><b>Application for Employer Identification Number</b></h4>
                              <p><b>(For use by employers, corporations, partnerships, trusts, estates, churches,
                                  government agencies, Indian tribal entities, certain individuals, and others.)</b></p>
                              <p>
                                <b>
                                  ▶ Go to www.irs.gov/FormSS4 for instructions and the latest information
                                </b>
                              </p>
                              <p><b>
                                  ▶ See separate instructions for each line.&nbsp;&nbsp; ▶ Keep a copy for your records
                                </b></p>

                            </div>
                          </div>

                        </div>
                        <div class="col-lg-4">
                          <p>OMB No. 1545-0003</p>
                          <label>EIN </label>
                          <label>{{OnboardClientDocumentBO?.application_Employer_Identification_NumberDocumentBO.einnumber}}</label>
                          <!-- <input type="text" class="form-control" [(ngModel)]="OnboardClientDocumentBO?.application_Employer_Identification_NumberDocumentBO.ein"> -->

                        </div>
                      </div>
                      <div class="row mt-4">
                        <div class="col-8">
                          <label>1&nbsp;&nbsp;Legal name of entity (or individual) for whom the EIN is being requested
                            <sup class="super-script">&nbsp;*&nbsp;</sup>
                          </label>
                          <input type="text" class="form-control"
                            [(ngModel)]="OnboardClientDocumentBO?.application_Employer_Identification_NumberDocumentBO.legalname">
                        </div>

                      </div>
                      <div class="row mt-2">
                        <div class="col-6">
                          <label>2&nbsp;&nbsp;Trade name of business (if different from name on line 1)
                          </label>
                          <input type="text" class="form-control"
                            [(ngModel)]="OnboardClientDocumentBO?.application_Employer_Identification_NumberDocumentBO.tradename">
                        </div>
                        <div class="col-6">
                          <label>3&nbsp;&nbsp; Executor, administrator, trustee, “care of” name <sup
                              class="super-script">&nbsp;*&nbsp;</sup>
                          </label>
                          <input type="text" class="form-control"
                            [(ngModel)]="OnboardClientDocumentBO?.application_Employer_Identification_NumberDocumentBO.agencyName">
                        </div>
                      </div>
                      <div class="row mt-2">
                        <div class="col-6">
                          <label>4a&nbsp;&nbsp;Mailing address(room, apt., suite no. and street) <sup
                              class="super-script">&nbsp;*&nbsp;</sup>
                          </label>
                          <textarea class="form-control"
                            [(ngModel)]="OnboardClientDocumentBO?.application_Employer_Identification_NumberDocumentBO.agencyMailingAddress"></textarea>
                        </div>
                        <div class="col-6">
                          <label>4b&nbsp;&nbsp;Street address(if Different)(Don’t enter a P.O. box)
                            <sup class="super-script">&nbsp;*&nbsp;</sup>
                          </label>
                          <textarea class="form-control"
                            [(ngModel)]="OnboardClientDocumentBO?.application_Employer_Identification_NumberDocumentBO.agencyStreet"></textarea>
                        </div>
                      </div>
                      <div class="row mt-2">
                        <div class="col-6">
                          <label>5a&nbsp;&nbsp; City, state, and ZIP code (if foreign, see instructions)
                          </label>
                          <textarea class="form-control"
                            [(ngModel)]="OnboardClientDocumentBO?.application_Employer_Identification_NumberDocumentBO.agencyCity_state_zip"></textarea>
                        </div>
                        <div class="col-6">
                          <label>5b&nbsp;&nbsp;City, state, and ZIP code (if foreign, see instructions)
                          </label>
                          <textarea class="form-control"
                            [(ngModel)]="OnboardClientDocumentBO?.application_Employer_Identification_NumberDocumentBO.agencyCity_state_zipIdifferent"></textarea>
                        </div>
                      </div>

                      <div class="row mt-2">
                        <div class="col-12">
                          <label>6&nbsp;&nbsp;County and state where principal business is located <sup
                              class="super-script">&nbsp;*&nbsp;</sup>
                          </label>
                          <input type="text" class="form-control"
                            [(ngModel)]="OnboardClientDocumentBO?.application_Employer_Identification_NumberDocumentBO.agencyCounty">
                        </div>
                      </div>
                      <div class="row mt-2">
                        <div class="col-6">
                          <label>7a&nbsp;&nbsp; Name of responsible party<sup class="super-script">&nbsp;*&nbsp;</sup>
                          </label>
                          <input type="text" class="form-control"
                            [(ngModel)]="OnboardClientDocumentBO?.application_Employer_Identification_NumberDocumentBO.nameofResponsibleParty">
                        </div>
                        <div class="col-6">
                          <label>7b&nbsp;&nbsp;SSN, ITIN, or EIN <sup class="super-script">&nbsp;*&nbsp;</sup>
                          </label>
                          <input type="text" class="form-control"
                            [(ngModel)]="OnboardClientDocumentBO?.application_Employer_Identification_NumberDocumentBO.ssn"
                            minlength="9" maxlength="9">
                        </div>





                      </div>

                      <div class="row mt-2">
                        <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12 aligned_form">
                          <label>8a Is this application for a limited liability company (LLC) (or a foreign equivalent)?
                            . . .
                            . . . . .
                          </label>



                          <div class="col-lg-2">
                            <label>yes</label>
                            <input type="radio" name="xxxx" value="true" id="ind1"
                              [(ngModel)]="OnboardClientDocumentBO.application_Employer_Identification_NumberDocumentBO.isapplicationLlc">
                          </div>
                          <div class="col-lg-2">
                            <label>no</label>
                            <input type="radio" name="xxxx" value="false" id="ind2"
                              [(ngModel)]="OnboardClientDocumentBO.application_Employer_Identification_NumberDocumentBO.isapplicationLlc">

                          </div>
                          <!-- <div class="ml-2 mt-1" *ngFor="let i of staffingList">
                            <input type="radio" [value]="i.Key"

                              [(ngModel)]="OnboardClientDocumentBO?.application_Employer_Identification_NumberDocumentBO.isapplicationLlc"
                              name="app1" />
                            {{i.Value}}
                          </div>  -->
                        </div>
                        <div class="col-6">
                          <label>8b&nbsp;&nbsp;If 8a is “Yes,” enter the number of
                            LLC members . . . . .
                          </label>
                          <input type="text" class="form-control"
                            [(ngModel)]="OnboardClientDocumentBO?.application_Employer_Identification_NumberDocumentBO.ifYesnumberofLlcMembers">
                        </div>


                      </div>




                      <div class="row mt-1">
                        <div class="col-lg-12 col-md-6 col-sm-12 col-xs-12 aligned_form">
                          <label>8c&nbsp;&nbsp;If 8a is “Yes,” was the LLC organized in the United States?
                          </label>

                          <div class="col-lg-2">
                            <label>yes</label>
                            <input type="radio" id="pre7" name="app2" value="true"
                              [(ngModel)]="OnboardClientDocumentBO.application_Employer_Identification_NumberDocumentBO.isllc_Organized_UnitedStates">
                          </div>
                          <div class="col-lg-2">
                            <label>no</label>
                            <input type="radio" id="pre8" name="app2" value="false"
                              [(ngModel)]="OnboardClientDocumentBO.application_Employer_Identification_NumberDocumentBO.isllc_Organized_UnitedStates">

                          </div>

                          <!-- <div class="ml-2" *ngFor="let i of staffingList">
                            <input type="radio" [value]="i.Key"
                              [(ngModel)]="OnboardClientDocumentBO?.application_Employer_Identification_NumberDocumentBO.isllc_Organized_UnitedStates"
                              name="app2" />
                            {{i.Value}}
                          </div>  -->
                        </div>



                      </div>

                      <div class="row mt-2 mb-3">
                        <div class="col">
                          <div class="row mt-2">
                            <div class="col-12">

                              <label>9a&nbsp;&nbsp;Type of entity (check only one box). Caution:</label><label>If 8a is
                                “Yes,” see the instructions for the correct box to check.
                              </label>
                            </div>
                          </div>
                          <div class="row mt-2">
                            <div class="col-lg-12">
                              <div class="row">
                                <div class="col-lg-1">
                                  <input type="radio" name="entity" value="one"
                                    [(ngModel)]="OnboardClientDocumentBO?.application_Employer_Identification_NumberDocumentBO.typeofEntity">
                                </div>
                                <!-- <div class="col-lg-1">
                                  <input type="radio" name="entity" value="one" 
                                    [(ngModel)]="OnboardClientDocumentBO.application_Employer_Identification_NumberDocumentBO.typeofEntity"
                                    id="preopt1">
                                </div> -->
                                <div class="col-lg-5">
                                  <label>Sole proprietor (SSN)
                                  </label>
                                </div>
                                <div class="col-6">
                                  <label>{{OnboardClientDocumentBO?.application_Employer_Identification_NumberDocumentBO.solepropritor_Ssn}}</label>
                                  <!-- <input type="text" class="form-control" [(ngModel)]="OnboardClientDocumentBO?.application_Employer_Identification_NumberDocumentBO.typeofEntity_SSN"
                                            minlength="9" maxlength="9" > -->
                                </div>
                              </div>
                              <div class="row mt-2">
                                <div class="col-lg-1">
                                  <input type="radio" name="entity" value="two"
                                    [(ngModel)]="OnboardClientDocumentBO?.application_Employer_Identification_NumberDocumentBO.typeofEntity">
                                </div>
                                <!-- <div class="col-lg-1">
                                  <input type="radio" name="entity" value="two"
                                    [(ngModel)]="OnboardClientDocumentBO.application_Employer_Identification_NumberDocumentBO.typeofEntity"
                                    id="preopt2">
                                </div> -->
                                <div class="col-lg-6">
                                  <label>Partnership
                                  </label>
                                </div>
                              </div>
                              <div class="row mt-2">
                                <div class="col-lg-1">
                                  <input type="radio" name="entity" value="three"
                                    [(ngModel)]="OnboardClientDocumentBO?.application_Employer_Identification_NumberDocumentBO.typeofEntity">
                                </div>
                                <!-- <div class="col-lg-1">
                                  <input type="radio" name="entity" value="three"
                                    [(ngModel)]="OnboardClientDocumentBO.application_Employer_Identification_NumberDocumentBO.typeofEntity"
                                    id="preopt3">
                                </div> -->
                                <div class="col-lg-5">
                                  <label> Corporation (enter form number to be filed) ▶ </label>
                                </div>
                                <div class="col-6">
                                  <label>{{OnboardClientDocumentBO?.application_Employer_Identification_NumberDocumentBO.corporationNumber}}</label>
                                  <!-- <input type="text" class="form-control"
                                            [(ngModel)]="OnboardClientDocumentBO?.application_Employer_Identification_NumberDocumentBO.corporation_enter_formm_number_tobe_field"> -->
                                </div>
                              </div>
                              <div class="row mt-2">
                                <div class="col-lg-1">
                                  <input type="radio" name="entity" value="four"
                                    [(ngModel)]="OnboardClientDocumentBO?.application_Employer_Identification_NumberDocumentBO.typeofEntity">
                                </div>

                                <!-- <div class="col-lg-1">
                                  <input type="radio" name="entity" value="four"
                                    [(ngModel)]="OnboardClientDocumentBO.application_Employer_Identification_NumberDocumentBO.typeofEntity"
                                    id="preopt4">
                                </div> -->
                                <div class="col-lg-6">
                                  <label>Personal service corporation
                                  </label>
                                </div>
                              </div>
                              <div class="row mt-2">
                                <div class="col-lg-1">
                                  <input type="radio" name="entity" value="five"
                                    [(ngModel)]="OnboardClientDocumentBO?.application_Employer_Identification_NumberDocumentBO.typeofEntity">
                                </div>
                                <!-- <div class="col-lg-1">
                                  <input type="radio" name="entity" value="five"
                                    [(ngModel)]="OnboardClientDocumentBO.application_Employer_Identification_NumberDocumentBO.typeofEntity"
                                    id="preopt5">
                                </div> -->
                                <div class="col-lg-6">
                                  <label>Church or church-controlled organization
                                  </label>
                                </div>
                              </div>
                              <div class="row mt-2">
                                <div class="col-lg-1">
                                  <input type="radio" name="entity" value="six"
                                    [(ngModel)]="OnboardClientDocumentBO?.application_Employer_Identification_NumberDocumentBO.typeofEntity">
                                </div>
                                <!-- <div class="col-lg-1">
                                  <input type="radio" name="entity" value="six"
                                    [(ngModel)]="OnboardClientDocumentBO.application_Employer_Identification_NumberDocumentBO.typeofEntity"
                                    id="preopt6">
                                </div> -->
                                <div class="col-lg-5">
                                  <label> Other nonprofit organization (specify) ▶ </label>
                                </div>
                                <div class="col-6">
                                  <label>{{OnboardClientDocumentBO?.application_Employer_Identification_NumberDocumentBO.otherNonProfitOrgText}}</label>
                                  <!-- <input type="text" class="form-control"
                                            [(ngModel)]="OnboardClientDocumentBO?.application_Employer_Identification_NumberDocumentBO.other_non_profit_Organization_specify"> -->
                                </div>
                              </div>
                              <div class="row mt-2">
                                <div class="col-lg-1">
                                  <input type="radio" name="entity" value="seven"
                                    [(ngModel)]="OnboardClientDocumentBO?.application_Employer_Identification_NumberDocumentBO.typeofEntity">
                                </div>
                                <!-- <div class="col-lg-1">
                                  <input type="radio" name="entity" value="seven"
                                    [(ngModel)]="OnboardClientDocumentBO.application_Employer_Identification_NumberDocumentBO.typeofEntity"
                                    id="preopt7">
                                </div> -->
                                <div class="col-lg-5">
                                  <label> Other (specify) ▶ </label>
                                </div>
                                <div class="col-6">
                                  <label>{{OnboardClientDocumentBO?.application_Employer_Identification_NumberDocumentBO.other_9aText}}</label>
                                  <!-- <input type="text" class="form-control"
                                            [(ngModel)]="OnboardClientDocumentBO?.application_Employer_Identification_NumberDocumentBO.type_Of_entity_other_specify" > -->
                                </div>
                              </div>
                            </div>

                          </div>
                          <div class="row mt-2">
                            <div class="col-lg-12">

                              <div class="row mt-2">
                                <div class="col-lg-1">
                                  <input type="radio" name="entity" value="eight"
                                    [(ngModel)]="OnboardClientDocumentBO?.application_Employer_Identification_NumberDocumentBO.typeofEntity">
                                </div>
                                <!-- <div class="col-lg-1">
                                  <input type="radio" name="entity" value="eight"
                                    [(ngModel)]="OnboardClientDocumentBO.application_Employer_Identification_NumberDocumentBO.typeofEntity"
                                    id="preopt8">
                                </div> -->
                                <div class="col-lg-6">
                                  <label>Estate (SSN of decedent)</label>
                                </div>
                                <div class="col-3">
                                  <label>{{OnboardClientDocumentBO?.application_Employer_Identification_NumberDocumentBO.estate_Ssn}}</label>

                                  <!-- <input type="text" class="form-control" 
                                            [(ngModel)]="OnboardClientDocumentBO?.application_Employer_Identification_NumberDocumentBO.estate_SSN_Of_Decedent"  minlength="9"   maxlength="9"> -->
                                </div>
                              </div>
                              <div class="row mt-2">
                                <div class="col-lg-1">
                                  <input type="radio" name="entity" value="nine"
                                    [(ngModel)]="OnboardClientDocumentBO?.application_Employer_Identification_NumberDocumentBO.typeofEntity">
                                </div>
                                <!-- <div class="col-lg-1">
                                  <input type="radio" name="entity" value="nine"
                                    [(ngModel)]="OnboardClientDocumentBO.application_Employer_Identification_NumberDocumentBO.typeofEntity"
                                    id="preopt9">
                                </div> -->
                                <div class="col-lg-5">
                                  <label>Plan administrator (TIN)</label>
                                </div>
                                <div class="col-6">
                                  <label
                                    class="break-word ">{{OnboardClientDocumentBO?.application_Employer_Identification_NumberDocumentBO.planAdministrator_Tin}}</label>
                                  <!-- <input type="text" class="form-control" [(ngModel)]="OnboardClientDocumentBO?.application_Employer_Identification_NumberDocumentBO.planAdminstrator_TIN"> -->
                                </div>
                              </div>
                              <div class="row mt-2">
                                <div class="col-lg-1">
                                  <input type="radio" name="entity" value="ten"
                                    [(ngModel)]="OnboardClientDocumentBO?.application_Employer_Identification_NumberDocumentBO.typeofEntity">
                                </div>
                                <!-- <div class="col-lg-1">
                                  <input type="radio" name="entity" value="ten"
                                    [(ngModel)]="OnboardClientDocumentBO.application_Employer_Identification_NumberDocumentBO.typeofEntity"
                                    id="preopt0">
                                </div> -->
                                <div class="col-lg-5">
                                  <label>Trust (TIN of grantor)</label>
                                </div>
                                <div class="col-6">
                                  <label
                                    class="break-word ">{{OnboardClientDocumentBO?.application_Employer_Identification_NumberDocumentBO.trust_Tin}}</label>
                                  <!-- <input type="text" class="form-control" [(ngModel)]="OnboardClientDocumentBO?.application_Employer_Identification_NumberDocumentBO.trust_TIN_of_Grantor"> -->

                                </div>
                              </div>
                              <div class="row mt-2">
                                <div class="col-lg-1">
                                  <input type="radio" name="entity" value="eleven"
                                    [(ngModel)]="OnboardClientDocumentBO?.application_Employer_Identification_NumberDocumentBO.typeofEntity">
                                </div>
                                <!-- <div class="col-lg-1">
                                  <input type="radio" name="entity" value="eleven"
                                    [(ngModel)]="OnboardClientDocumentBO.application_Employer_Identification_NumberDocumentBO.typeofEntity"
                                    id="preopt11">
                                </div> -->
                                <div class="col-lg-5">
                                  <label>Military/National Guard </label>
                                </div>
                                <div class="col-lg-1">
                                  <input type="radio" name="entity" value="tweleve"
                                    [(ngModel)]="OnboardClientDocumentBO?.application_Employer_Identification_NumberDocumentBO.typeofEntity">
                                </div>
                                <!-- <div class="col-lg-1">
                                  <input type="radio" name="entity" value="tweleve"
                                    [(ngModel)]="OnboardClientDocumentBO.application_Employer_Identification_NumberDocumentBO.typeofEntity"
                                    id="preopt12">
                                </div> -->
                                <div class="col-lg-5">
                                  <label> State/local government</label>
                                </div>
                              </div>
                              <div class="row mt-2">
                                <div class="col-lg-1">
                                  <input type="radio" name="entity" value="thirdteen"
                                    [(ngModel)]="OnboardClientDocumentBO?.application_Employer_Identification_NumberDocumentBO.typeofEntity">
                                </div>
                                <!-- <div class="col-lg-1">
                                  <input type="radio" name="entity" value="thirdteen"
                                    [(ngModel)]="OnboardClientDocumentBO.application_Employer_Identification_NumberDocumentBO.typeofEntity"
                                    id="preopt13">
                                </div> -->
                                <div class="col-lg-5">
                                  <label>Farmers’ cooperative</label>
                                </div>
                                <div class="col-lg-1">
                                  <input type="radio" name="entity" value="fourteen"
                                    [(ngModel)]="OnboardClientDocumentBO?.application_Employer_Identification_NumberDocumentBO.typeofEntity">
                                </div>
                                <!-- <div class="col-lg-1">
                                  <input type="radio" name="entity" value="fourteen"
                                    [(ngModel)]="OnboardClientDocumentBO.application_Employer_Identification_NumberDocumentBO.typeofEntity"
                                    id="preopt14">
                                </div> -->
                                <div class="col-lg-5">
                                  <label> Federal government</label>
                                </div>
                              </div>
                              <div class="row mt-2">
                                <div class="col-lg-1">
                                  <input type="radio" name="entity" value="fifteen"
                                    [(ngModel)]="OnboardClientDocumentBO?.application_Employer_Identification_NumberDocumentBO.typeofEntity">
                                </div>
                                <!-- <div class="col-lg-1">
                                  <input type="radio" name="entity" value="fifteen"
                                    [(ngModel)]="OnboardClientDocumentBO.application_Employer_Identification_NumberDocumentBO.typeofEntity"
                                    id="preopt15">
                                </div> -->
                                <div class="col-lg-5">
                                  <label>REMIC </label>
                                </div>
                                <div class="col-lg-1">
                                  <input type="radio" name="entity" value="sixteen"
                                    [(ngModel)]="OnboardClientDocumentBO?.application_Employer_Identification_NumberDocumentBO.typeofEntity">
                                </div>
                                <!-- <div class="col-lg-1">
                                  <input type="radio" name="entity" value="sixteen"
                                    [(ngModel)]="OnboardClientDocumentBO.application_Employer_Identification_NumberDocumentBO.typeofEntity"
                                    id="preopt16">
                                </div> -->
                                <div class="col-lg-5">
                                  <label>Indian tribal governments/enterprises</label>
                                </div>
                              </div>
                              <div class="row mt-2">
                                <div class="col-lg-1">
                                  <input type="radio" name="entity" value="seventeen"
                                    [(ngModel)]="OnboardClientDocumentBO?.application_Employer_Identification_NumberDocumentBO.typeofEntity">
                                </div>
                                <!-- <div class="col-lg-1">
                                  <input type="radio" name="entity" value="seventeen"
                                    [(ngModel)]="OnboardClientDocumentBO.application_Employer_Identification_NumberDocumentBO.typeofEntity"
                                    id="preopt17">
                                </div> -->
                                <div class="col-lg-5">
                                  <label>Group Exemption Number (GEN) if any ▶</label>
                                </div>
                                <div class="col-6">
                                  <label>{{OnboardClientDocumentBO?.application_Employer_Identification_NumberDocumentBO.genIfAny}}</label>
                                  <!-- <input type="text" class="form-control"
                                            [(ngModel)]="OnboardClientDocumentBO?.application_Employer_Identification_NumberDocumentBO.group_Excemption_Number_GEN"> -->
                                </div>
                              </div>

                            </div>


                          </div>
                        </div>
                      </div>
                      <div class="row mt-2">
                        <div class="col-4">
                          <p>9b&nbsp;&nbsp; If a corporation, name the state or foreign country (if
                            applicable) where incorporated</p>
                        </div>
                        <div class="col-4">
                          <label>State
                          </label>
                          <ng-select
                            [(ngModel)]="OnboardClientDocumentBO?.application_Employer_Identification_NumberDocumentBO.state_9b"
                            [items]="stateList" class="width25" [searchable]="true" [clearable]="true" bindLabel="name"
                            bindValue="abbreviation"></ng-select>
                        </div>
                        <div class="col-4">
                          <label>Foreign country
                          </label>
                          <input type="text" class="form-control"
                            [(ngModel)]="OnboardClientDocumentBO?.application_Employer_Identification_NumberDocumentBO.foreignCountry">
                        </div>
                      </div>


                      <div class="row mt-2 mb-3">
                        <div class="col">
                          <div class="row">

                            <div class="col-12">

                              <label>10&nbsp;&nbsp;Reason for applying (check only one box)
                              </label>
                            </div>
                          </div>
                          <div class="row">
                            <div class="col-lg-12">
                              <div class="row">
                                <div class="col-lg-1">
                                  <input type="radio" name="business" value="a"
                                    [(ngModel)]="OnboardClientDocumentBO?.application_Employer_Identification_NumberDocumentBO.reasonForAppling"
                                    id="1">
                                </div>
                                <!-- <div class="col-lg-1">
                                  <input type="radio" name="business" value="a"
                                    [(ngModel)]="OnboardClientDocumentBO?.application_Employer_Identification_NumberDocumentBO.startedNewbusinessSpecifyType"
                                    id="1">
                                </div> -->
                                <div class="col-lg-6">
                                  <label>Started new business (specify type) ▶
                                  </label>
                                </div>
                                <div class="col-3">
                                  <label>{{OnboardClientDocumentBO?.application_Employer_Identification_NumberDocumentBO.startedNewbusinessSpecifyType}}</label>
                                  <!-- <input type="text" class="form-control"
                                            [(ngModel)]="OnboardClientDocumentBO?.application_Employer_Identification_NumberDocumentBO.reasonForAppling_Specify_type"> -->
                                </div>
                              </div>
                              <div class="row mt-2">
                                <div class="col-lg-1">
                                  <input type="radio" name="business" value="b"
                                    [(ngModel)]="OnboardClientDocumentBO?.application_Employer_Identification_NumberDocumentBO.reasonForAppling"
                                    id="2">
                                </div>
                                <div class="col-lg-6">
                                  <label>Hired employees (Check the box and see line 13.)
                                  </label>
                                </div>
                              </div>
                              <div class="row mt-2">
                                <div class="col-lg-1">
                                  <input type="radio" name="business" value="c"
                                    [(ngModel)]="OnboardClientDocumentBO?.application_Employer_Identification_NumberDocumentBO.reasonForAppling"
                                    id="3">

                                </div>
                                <!-- <div class="col-lg-1">
                                  <input type="radio" name="business" value="c"
                                    [(ngModel)]="OnboardClientDocumentBO?.application_Employer_Identification_NumberDocumentBO.reasonForAppling"
                                    id="3">

                                </div> -->
                                <div class="col-lg-6">
                                  <label>Compliance with IRS withholding regulations
                                  </label>
                                </div>
                              </div>

                              <div class="row mt-2">
                                <div class="col-lg-1">
                                  <input type="radio" name="business" value="d"
                                    [(ngModel)]="OnboardClientDocumentBO?.application_Employer_Identification_NumberDocumentBO.reasonForAppling"
                                    id="4">

                                </div>
                                <!-- <div class="col-lg-1">
                                  <input type="radio" name="business" value="d"
                                    [(ngModel)]="OnboardClientDocumentBO?.application_Employer_Identification_NumberDocumentBO.reasonForAppling"
                                    id="4">

                                </div> -->
                                <div class="col-lg-6">
                                  <label>Other (specify) ▶</label>
                                </div>
                                <div class="col-3">
                                  <!-- <input type="text" class="form-control"  [disabled]="clientonboardBO?.datalist?.onboardStatusLidName == 'SUBMITTED'|| !snbool2  "     [(ngModel)]="OnboardClientDocumentBO.application_Employer_Identification_NumberDocumentBO.other_Specify1" > -->
                                  <label>{{OnboardClientDocumentBO?.application_Employer_Identification_NumberDocumentBO.other_10_specify}}</label>
                                </div>
                              </div>

                            </div>

                          </div>
                          <div class="row">
                            <div class="col-lg-12">

                              <div class="row mt-2">
                                <div class="col-lg-1">
                                  <input type="radio" name="business" value="f"
                                    [(ngModel)]="OnboardClientDocumentBO?.application_Employer_Identification_NumberDocumentBO.reasonForAppling"
                                    id="6">
                                </div>
                                <!-- <div class="col-lg-1">
                                  <input type="radio" name="business" value="f"
                                    [(ngModel)]="OnboardClientDocumentBO?.application_Employer_Identification_NumberDocumentBO.reasonForAppling"
                                    id="6">
                                </div> -->
                                <div class="col-lg-6">
                                  <label>Banking purpose (specify purpose) ▶</label>
                                </div>
                                <div class="col-3">
                                  <label>{{OnboardClientDocumentBO?.application_Employer_Identification_NumberDocumentBO.backingPurposeSpecifyType}}</label>
                                  <!-- <input type="text" class="form-control"
                                            [(ngModel)]="OnboardClientDocumentBO?.application_Employer_Identification_NumberDocumentBO.bankingPurpose_specify_purpose" > -->
                                </div>
                              </div>
                              <div class="row mt-2">
                                <div class="col-lg-1">
                                  <input type="radio" name="business" value="g"
                                    [(ngModel)]="OnboardClientDocumentBO?.application_Employer_Identification_NumberDocumentBO.reasonForAppling"
                                    id="7">
                                </div>
                                <!-- <div class="col-lg-1">
                                  <input type="radio" name="business" value="g"
                                    [(ngModel)]="OnboardClientDocumentBO?.application_Employer_Identification_NumberDocumentBO.reasonForAppling"
                                    id="7">
                                </div> -->
                                <div class="col-lg-6">
                                  <label>Changed type of organization (specify new type) ▶</label>
                                </div>
                                <div class="col-3">
                                  <label>{{OnboardClientDocumentBO?.application_Employer_Identification_NumberDocumentBO.changedTypeOrgType}}</label>

                                  <!-- <input type="text" class="form-control"
                                            [(ngModel)]="OnboardClientDocumentBO?.application_Employer_Identification_NumberDocumentBO.changed_type_Organization_Specify_newtype"> -->
                                </div>
                              </div>
                              <div class="row mt-2">
                                <div class="col-lg-1">
                                  <input type="radio" name="business" value="h"
                                    [(ngModel)]="OnboardClientDocumentBO?.application_Employer_Identification_NumberDocumentBO.reasonForAppling"
                                    id="8">
                                </div>
                                <!-- <div class="col-lg-1">
                                  <input type="radio" name="business" value="h"
                                    [(ngModel)]="OnboardClientDocumentBO?.application_Employer_Identification_NumberDocumentBO.reasonForAppling"
                                    id="8">
                                </div> -->
                                <div class="col-lg-6">
                                  <label>Purchased going business</label>
                                </div>
                                <div class="col-3">
                                  <label>{{OnboardClientDocumentBO?.application_Employer_Identification_NumberDocumentBO.purchaseedGoingBusinesstext}}</label>
                                  <!-- <input type="text" class="form-control"
                                            [(ngModel)]="OnboardClientDocumentBO?.application_Employer_Identification_NumberDocumentBO.purchased_going_bussiness"> -->
                                </div>
                              </div>

                              <div class="row mt-2">
                                <div class="col-lg-1">
                                  <input type="radio" name="business" value="i"
                                    [(ngModel)]="OnboardClientDocumentBO?.application_Employer_Identification_NumberDocumentBO.reasonForAppling"
                                    id="9">
                                </div>
                                <!-- <div class="col-lg-1">
                                  <input type="radio" name="business" value="i"
                                    [(ngModel)]="OnboardClientDocumentBO?.application_Employer_Identification_NumberDocumentBO.reasonForAppling"
                                    id="9">
                                </div> -->
                                <div class="col-lg-6">
                                  <label>Created a trust (specify type) ▶
                                  </label>
                                </div>
                                <div class="col-3">
                                  <label>{{OnboardClientDocumentBO?.application_Employer_Identification_NumberDocumentBO.createdTrustSpecifyType}}</label>
                                  <!-- <input type="text" class="form-control"
                                            [(ngModel)]="OnboardClientDocumentBO?.application_Employer_Identification_NumberDocumentBO.created_trust_specify_type"> -->
                                </div>
                              </div>
                              <div class="row mt-2">
                                <div class="col-lg-1">
                                  <input type="radio" name="business" value="j"
                                    [(ngModel)]="OnboardClientDocumentBO?.application_Employer_Identification_NumberDocumentBO.reasonForAppling"
                                    id="10">
                                </div>
                                <!-- <div class="col-lg-1">
                                  <input type="radio" name="business" value="j"
                                    [(ngModel)]="OnboardClientDocumentBO?.application_Employer_Identification_NumberDocumentBO.reasonForAppling"
                                    id="10">
                                </div> -->
                                <div class="col-lg-6">
                                  <label>Created a pension plan (specify type) ▶
                                  </label>
                                </div>
                                <div class="col-3">
                                  <label>{{OnboardClientDocumentBO?.application_Employer_Identification_NumberDocumentBO.createdPensionPlanSpecifyType}}</label>
                                  <!-- <input type="text" class="form-control"
                                            [(ngModel)]="OnboardClientDocumentBO?.application_Employer_Identification_NumberDocumentBO.created_pension_plan_Specify_type"> -->
                                </div>
                              </div>

                            </div>
                          </div>
                        </div>
                      </div>






                      <div class="row mt-2">

                        <div class="col-6">
                          <label>11&nbsp;&nbsp;Date business started or acquired (month, day, year). See instructions
                          </label>
                          <label>{{OnboardClientDocumentBO?.application_Employer_Identification_NumberDocumentBO.dateofBusinessStarted}}</label>
                          <!-- <my-date-picker class="w-100" [options]="myDatePickerOptionsDOB"
                              placeholder="mm/dd/yyyy" [selDate]="OnboardClientDocumentBO?.application_Employer_Identification_NumberDocumentBO.date_Business_started_or_acquired"
                            >
        
                            </my-date-picker> -->
                        </div>
                        <div class="col-6">
                          <label>12&nbsp;&nbsp;Closing month of accounting year
                          </label>

                          <input type="string" class="form-control"
                            [(ngModel)]="OnboardClientDocumentBO?.application_Employer_Identification_NumberDocumentBO.closingMonth">



                        </div>
                      </div>
                      <div class="row mt-2">

                        <div class="col-6">
                          <p>13&nbsp;&nbsp;Highest number of employees expected in the next 12 months (enter -0- if
                            none). If no employees expected, skip line 14.</p>
                          <div class="row">
                            <div class="col-3">
                              <label>Agricultural
                              </label>

                            </div>
                            <div class="col-8">
                              <input type="text" class="form-control"
                                [(ngModel)]="OnboardClientDocumentBO?.application_Employer_Identification_NumberDocumentBO.no_of_employees_Agriculture">
                            </div>
                          </div>
                          <div class="row mt-2">
                            <div class="col-3">
                              <label>Household
                              </label>

                            </div>
                            <div class="col-8">
                              <input type="text" class="form-control"
                                [(ngModel)]="OnboardClientDocumentBO?.application_Employer_Identification_NumberDocumentBO.no_of_employees_HouseHold">
                            </div>
                          </div>
                          <div class="row mt-2">
                            <div class="col-3">
                              <label>Other
                              </label>

                            </div>
                            <div class="col-8">
                              <input type="text" class="form-control"
                                [(ngModel)]="OnboardClientDocumentBO?.application_Employer_Identification_NumberDocumentBO.no_of_employees_other">
                            </div>
                          </div>


                        </div>
                        <div class="col-6">
                          <div class="col-lg-12">
                            <p>14&nbsp;&nbsp;
                              If you expect your employment tax liability to be $1,000 or
                              less in a full calendar year and want to file Form 944
                              annually instead of Forms 941 quarterly, check here.
                              (Your employment tax liability generally will be $1,000
                              or less if you expect to pay $5,000 or less in total wages.)
                              If you don’t check this box, you must file Form 941 for
                              every quarter&nbsp;<input type="checkbox"
                                [(ngModel)]="OnboardClientDocumentBO?.application_Employer_Identification_NumberDocumentBO.file_Form_941_every_quarter">
                            </p>
                          </div>
                        </div>
                      </div>
                      <div class="row mt-2">
                        <div class="col-12">
                          <p>15&nbsp;&nbsp;
                            First date wages or annuities were paid (month, day, year). Note: If applicant is a
                            withholding
                            agent, enter date income will first be paid to
                            nonresident alien (month, day, year) . . . . . . . . . . . ▶
                            <label>{{OnboardClientDocumentBO?.application_Employer_Identification_NumberDocumentBO.first_date_wages_Annuities_were_paid}}</label>
                            <!-- <my-date-picker class="w-100" style="display:inline-block;width:150px;" [options]="myDatePickerOptionsDOB" id="datepicker"
                                  placeholder="mm/dd/yyyy" [selDate]="OnboardClientDocumentBO?.application_Employer_Identification_NumberDocumentBO.first_date_wages_Annuities_were_paid"
                                 >
            
                                </my-date-picker> -->

                          </p>

                        </div>

                      </div>
                      <div class="row mt-2 mb-3">
                        <div class="col">
                          <div class="row">
                            <div class="col-12">
                              <p>16&nbsp;&nbsp;Check one box that best describes the principal activity of your
                                business.</p>
                              <div class="row mt-2">
                                <div class="col-lg-1">
                                  <input type="radio" value=""
                                    [(ngModel)]="OnboardClientDocumentBO?.application_Employer_Identification_NumberDocumentBO.pricipalActivities"
                                    id="aa" name="principal">
                                </div>
                                <div class="col-lg-3">
                                  <label>pricipalActivities </label>
                                </div>
                                <div class="col-lg-1">
                                  <input type="radio" value="r"
                                    [(ngModel)]="OnboardClientDocumentBO?.application_Employer_Identification_NumberDocumentBO.pricipalActivities"
                                    id="bb" name="principal">
                                </div>
                                <!-- <div class="col-lg-1">
                                  <input type="radio" value=""
                                    [(ngModel)]="OnboardClientDocumentBO?.application_Employer_Identification_NumberDocumentBO.pricipalActivities"
                                    id="bb" name="principal">
                                </div> -->
                                <div class="col-lg-3">
                                  <label>Rental & leasing </label>
                                </div>
                                <div class="col-lg-1">
                                  <input type="radio" value="s"
                                    [(ngModel)]="OnboardClientDocumentBO?.application_Employer_Identification_NumberDocumentBO.pricipalActivities"
                                    id="cc" name="principal">
                                </div>
                                <!-- <div class="col-lg-1">
                                  <input type="radio" value=""
                                    [(ngModel)]="OnboardClientDocumentBO?.application_Employer_Identification_NumberDocumentBO.pricipalActivities"
                                    id="cc" name="principal">
                                </div> -->
                                <div class="col-lg-3">
                                  <label>Transportation & warehousing</label>
                                </div>
                              </div>
                              <div class="row mt-2">
                                <div class="col-lg-1">
                                  <input type="radio" value="t"
                                    [(ngModel)]="OnboardClientDocumentBO?.application_Employer_Identification_NumberDocumentBO.pricipalActivities"
                                    id="dd" name="principal">
                                </div>
                                <!-- <div class="col-lg-1">
                                  <input type="radio" value=""
                                    [(ngModel)]="OnboardClientDocumentBO?.application_Employer_Identification_NumberDocumentBO.pricipalActivities"
                                    id="dd" name="principal">
                                </div> -->
                                <div class="col-lg-3">
                                  <label>Real estate</label>
                                </div>
                                <div class="col-lg-1">
                                  <input type="radio" value="u"
                                    [(ngModel)]="OnboardClientDocumentBO?.application_Employer_Identification_NumberDocumentBO.pricipalActivities"
                                    id="ee" name="principal">
                                </div>
                                <!-- <div class="col-lg-1">
                                  <input type="radio" value=""
                                    [(ngModel)]="OnboardClientDocumentBO?.application_Employer_Identification_NumberDocumentBO.pricipalActivities"
                                    id="ee" name="principal">
                                </div> -->
                                <div class="col-lg-3">
                                  <label>Manufacturing </label>
                                </div>
                                <div class="col-lg-1">
                                  <input type="radio" value="v"
                                    [(ngModel)]="OnboardClientDocumentBO?.application_Employer_Identification_NumberDocumentBO.pricipalActivities"
                                    id="ff" name="principal">
                                </div>
                                <!-- <div class="col-lg-1">
                                  <input type="radio" value=""
                                    [(ngModel)]="OnboardClientDocumentBO?.application_Employer_Identification_NumberDocumentBO.pricipalActivities"
                                    id="ff" name="principal">
                                </div> -->
                                <div class="col-lg-3">
                                  <label>Finance &
                                    insurance</label>
                                </div>

                              </div>
                            </div>
                          </div>
                          <div class="row">
                            <div class="col-12">
                              <div class="row mt-2">
                                <div class="col-lg-1">
                                  <input type="radio" value="k"
                                    [(ngModel)]="OnboardClientDocumentBO?.application_Employer_Identification_NumberDocumentBO.pricipalActivities"
                                    id="gg" name="principal">
                                </div>
                                <!-- <div class="col-lg-1">
                                  <input type="radio" value="k"
                                    [(ngModel)]="OnboardClientDocumentBO?.application_Employer_Identification_NumberDocumentBO.pricipalActivities"
                                    id="gg" name="principal">
                                </div> -->
                                <div class="col-lg-3">
                                  <label> Health care & social assistance </label>
                                </div>
                                <div class="col-lg-1">
                                  <input type="radio" value="l"
                                    [(ngModel)]="OnboardClientDocumentBO?.application_Employer_Identification_NumberDocumentBO.pricipalActivities"
                                    id="hh" name="principal">
                                </div>
                                <!-- <div class="col-lg-1">
                                  <input type="radio" value="l"
                                    [(ngModel)]="OnboardClientDocumentBO?.application_Employer_Identification_NumberDocumentBO.pricipalActivities"
                                    id="hh" name="principal">
                                </div> -->
                                <div class="col-lg-3">
                                  <label>Wholesale-agent/broker </label>
                                </div>

                              </div>
                              <div class="row mt-2">
                                <div class="col-lg-1">
                                  <input type="radio" value="m"
                                    [(ngModel)]="OnboardClientDocumentBO?.application_Employer_Identification_NumberDocumentBO.pricipalActivities"
                                    id="ii" name="principal">
                                </div>
                                <!-- <div class="col-lg-1">
                                  <input type="radio" value="m"
                                    [(ngModel)]="OnboardClientDocumentBO?.application_Employer_Identification_NumberDocumentBO.pricipalActivities"
                                    id="ii" name="principal">
                                </div> -->
                                <div class="col-lg-3">
                                  <label>Accommodation & food service</label>
                                </div>
                                <div class="col-lg-1">
                                  <input type="radio" value="n"
                                    [(ngModel)]="OnboardClientDocumentBO?.application_Employer_Identification_NumberDocumentBO.pricipalActivities"
                                    id="jj" name="principal">
                                </div>
                                <!-- <div class="col-lg-1">
                                  <input type="radio" value="n"
                                    [(ngModel)]="OnboardClientDocumentBO?.application_Employer_Identification_NumberDocumentBO.pricipalActivities"
                                    id="jj" name="principal">
                                </div> -->
                                <div class="col-lg-3">
                                  <label> Wholesale-other</label>
                                </div>
                                <div class="col-lg-1">
                                  <input type="radio" value="o"
                                    [(ngModel)]="OnboardClientDocumentBO?.application_Employer_Identification_NumberDocumentBO.pricipalActivities"
                                    id="kk" name="principal">
                                </div>
                                <!-- <div class="col-lg-1">
                                  <input type="radio" value="o"
                                    [(ngModel)]="OnboardClientDocumentBO?.application_Employer_Identification_NumberDocumentBO.pricipalActivities"
                                    id="kk" name="principal">
                                </div> -->
                                <div class="col-lg-3">
                                  <label> Retail </label>
                                </div>
                              </div>
                              <div class="row mt-2">
                                <div class="col-lg-1">
                                  <input type="radio" value="p"
                                    [(ngModel)]="OnboardClientDocumentBO?.application_Employer_Identification_NumberDocumentBO.pricipalActivities"
                                    id="ll" name="principal">
                                </div>
                                <!-- <div class="col-lg-1">
                                  <input type="radio" value="p"
                                    [(ngModel)]="OnboardClientDocumentBO?.application_Employer_Identification_NumberDocumentBO.pricipalActivities"
                                    id="ll" name="principal">
                                </div> -->
                                <div class="col-lg-3">
                                  <label>Other (specify) ▶</label>
                                </div>
                                <div class="col-lg-7">
                                  <input type="text" class="form-control"
                                    [(ngModel)]="OnboardClientDocumentBO?.application_Employer_Identification_NumberDocumentBO.othertext_16">
                                </div>


                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="row mt-2">
                        <div class="col-12">
                          <p> 17&nbsp;&nbsp;Indicate principal line of merchandise sold, specific pricipalActivities
                            work done,
                            products produced, or services provided.<input type="text" class="form-control "
                              [(ngModel)]="OnboardClientDocumentBO?.application_Employer_Identification_NumberDocumentBO.indicate_Principle_line"
                              style="display:inline-block;width:250px;"></p>

                        </div>
                      </div>

                      <div class="row mt-1">
                        <div class="col-lg-12 col-md-6 col-sm-12 col-xs-12 aligned_form">
                          <p>18&nbsp;&nbsp;Has the applicant entity shown on line 1 ever applied for and received an
                            EIN? Yes No
                            If “Yes,” write previous EIN here ▶.<input type="text"
                              [(ngModel)]="OnboardClientDocumentBO?.application_Employer_Identification_NumberDocumentBO.applicant_entity_shown_line1_everapplied_for_and_received_an_EIN_if_yes"
                              class="form-control " style="display:inline-block;width:250px;"></p>
                          <!-- <div class="ml-2" *ngFor="let i of staffingList">
                                <input type="radio" [value]="i.Key"
                                  [(ngModel)]="OnboardClientDocumentBO?.application_Employer_Identification_NumberDocumentBO.applicant_entity_shown_line1_everapplied_for_and_received_an_EIN"
                                  name="app3" />
                                {{i.Value}}
                              </div> -->
                        </div>



                      </div>


                      <div class="row mt-2 mb-2">
                        <div class="col">
                          <div class="card ">
                            <div class="card-header">
                              <h5>Complete this section only if you want to authorize the named individual to receive
                                the
                                entity’s EIN and answer questions about the completion of this form.</h5>
                            </div>
                            <div class="card-body" style="padding:45px;">

                              <div class="row">
                                <div class="col-12">
                                  <div class="card">
                                    <div class="card-body">
                                      <h4><b>Third
                                          Party
                                          Designee</b></h4>

                                    </div>
                                  </div>

                                </div>
                              </div>
                              <div class="row">



                                <div class="col-6">
                                  <label>Designee’s name </label>

                                  <input type="text" class="form-control"
                                    [(ngModel)]="OnboardClientDocumentBO?.application_Employer_Identification_NumberDocumentBO.designeesName">
                                  <label>Address and ZIP code
                                  </label>
                                  <textarea class="form-control"
                                    [(ngModel)]="OnboardClientDocumentBO?.application_Employer_Identification_NumberDocumentBO.designees_Address_ZipCode"></textarea>
                                </div>
                                <div class="col-6">
                                  <label>Designee’s telephone number (include area code)</label>

                                  <input type="text" class="form-control"
                                    [(ngModel)]="OnboardClientDocumentBO?.application_Employer_Identification_NumberDocumentBO.designees_telephone_number">
                                  <label>Designee’s fax number (include area code)</label>
                                  <input type="text" class="form-control"
                                    [(ngModel)]="OnboardClientDocumentBO?.application_Employer_Identification_NumberDocumentBO.designees_Fax_Number">
                                </div>
                              </div>

                              <div class="row mt-2">
                                <div class="col-7">
                                  <div class="row">
                                    <div class="col-12">
                                      <p>Under penalties of perjury, I declare that I have examined this application,
                                        and to
                                        the best of my knowledge and belief, it is true, correct, and complete.
                                        Name and title (type or print clearly) ▶<input type="text"
                                          [(ngModel)]="OnboardClientDocumentBO?.application_Employer_Identification_NumberDocumentBO.under_penalties_of_perjury_Name_title"
                                          class="form-control " style="display:inline-block;width:150px;">
                                        <ng-select [items]="selflist" class="width25" [searchable]="true"
                                          style="display:inline-block;width:150px;" [clearable]="true" bindLabel="Value"
                                          bindValue="Key" placeholder="Choose One"
                                          [(ngModel)]="OnboardClientDocumentBO?.application_Employer_Identification_NumberDocumentBO.under_penalties_of_perjury_Name_title1">
                                        </ng-select>
                                      </p>

                                    </div>
                                  </div>
                                </div>
                                <div class="col-5">

                                  <label>Applicant’s telephone number (include area code)</label>
                                  <input type="text" class="form-control"
                                    [(ngModel)]="OnboardClientDocumentBO?.application_Employer_Identification_NumberDocumentBO.applicants_Telephone_Number"
                                    minlength="14" maxlength="14">




                                </div>
                              </div>
                              <div class="row mt-2">
                                <div class="col-7">

                                  <div class="row mt-4 ml-2">
                                    <div class="col-6">
                                      <button type="button" class="btn btn-primary" data-bs-toggle="modal"
                                        data-bs-target="#user">
                                        Signature
                                      </button> <sup class="super-script">&nbsp;*&nbsp;</sup>
                                    </div>
                                    <div class="col-lg-2">
                                      <label for="cname">Date: <sup class="super-script">&nbsp;*&nbsp;</sup></label>
                                    </div>
                                    <div class="col-lg-4">
                                      <label>{{OnboardClientDocumentBO?.application_Employer_Identification_NumberDocumentBO.date}}</label>
                                      <!-- <my-date-picker class="w-100" [options]="myDatePickerOptionsDOB"
                                            placeholder="mm/dd/yyyy" [selDate]="OnboardClientDocumentBO?.application_Employer_Identification_NumberDocumentBO.date"
                                           >
        
                                          </my-date-picker> -->
                                    </div>
                                  </div>





                                  <div class="row mt-2 mb-2">

                                    <div> <label class="font-weight "> <img *ngIf="signature!=''&& signature!=null "
                                          src={{signature}} class="form-control mt-3 " style="width: 179px;height:80px;"
                                          alt="employeeSign" width="48" height="48" /></label>

                                    </div>

                                  </div>


                                </div>
                                <div class="col-5">
                                  <label>Applicant’s fax number (include area code)</label>
                                  <input type="text" class="form-control"
                                    [(ngModel)]="OnboardClientDocumentBO?.application_Employer_Identification_NumberDocumentBO.applicants_Fax_Number">
                                </div>
                              </div>

                            </div>
                          </div>
                        </div>
                      </div>



                    </div>
                    <div class="card-footer">
                      <div class="row">

                        <!-- <div class="col text-right mb-3 mt-3">
                              
                              <button type="button"  class="btn blue-btn mr-3"  (click)="save()"  [disabled]="signature==null||signature==undefined||signature==''||OnboardClientDocumentBO?.application_Employer_Identification_NumberDocumentBO.legalName==''||OnboardClientDocumentBO?.application_Employer_Identification_NumberDocumentBO.legalName==null||OnboardClientDocumentBO?.application_Employer_Identification_NumberDocumentBO.legalName==undefined|| OnboardClientDocumentBO?.application_Employer_Identification_NumberDocumentBO.executor_Administrator_Trustee_CareOfName==null||OnboardClientDocumentBO?.application_Employer_Identification_NumberDocumentBO.executor_Administrator_Trustee_CareOfName==''||OnboardClientDocumentBO?.application_Employer_Identification_NumberDocumentBO.executor_Administrator_Trustee_CareOfName==undefined||OnboardClientDocumentBO?.application_Employer_Identification_NumberDocumentBO.mailingaddress==''||OnboardClientDocumentBO?.application_Employer_Identification_NumberDocumentBO.mailingaddress==undefined||OnboardClientDocumentBO?.application_Employer_Identification_NumberDocumentBO.mailingaddress==null||OnboardClientDocumentBO?.application_Employer_Identification_NumberDocumentBO.city_state_Zipcode==null||OnboardClientDocumentBO?.application_Employer_Identification_NumberDocumentBO.city_state_Zipcode==undefined||OnboardClientDocumentBO?.application_Employer_Identification_NumberDocumentBO.city_state_Zipcode==''||OnboardClientDocumentBO?.application_Employer_Identification_NumberDocumentBO.country_and_state_where_Principle_Business_located==null||OnboardClientDocumentBO?.application_Employer_Identification_NumberDocumentBO.country_and_state_where_Principle_Business_located==undefined||OnboardClientDocumentBO?.application_Employer_Identification_NumberDocumentBO.country_and_state_where_Principle_Business_located==''||OnboardClientDocumentBO?.application_Employer_Identification_NumberDocumentBO.responsibleParty==null||OnboardClientDocumentBO?.application_Employer_Identification_NumberDocumentBO.responsibleParty==undefined||OnboardClientDocumentBO?.application_Employer_Identification_NumberDocumentBO.responsibleParty==''||OnboardClientDocumentBO?.application_Employer_Identification_NumberDocumentBO.ssN_ITIN_EIN==null||OnboardClientDocumentBO?.application_Employer_Identification_NumberDocumentBO.ssN_ITIN_EIN==undefined||OnboardClientDocumentBO?.application_Employer_Identification_NumberDocumentBO.ssN_ITIN_EIN==''||OnboardClientDocumentBO?.application_Employer_Identification_NumberDocumentBO.date==''||OnboardClientDocumentBO?.application_Employer_Identification_NumberDocumentBO.date==undefined||OnboardClientDocumentBO?.application_Employer_Identification_NumberDocumentBO.date==null"  class="btn blue-btn"
                               >Save</button>
                              <button type="button" class="btn blue-btn" *ngIf="isUpdate && !clientonboardBO.edit">Update
                              
                              </button>
                              <button type="button" class="btn blue-btn ml-3" data-bs-dismiss="modal">Clear</button>
                            </div> -->

                      </div>
                    </div>
                  </div>
                </div>
              </div>


              <div class="row mb-4 mt-4">
                <div class="col">
                  <div class="card ">
                    <div class="card-body" style="padding:65px;">
                      <h3>Form <b>2678 Employer/Payer Appointment of Agent</b></h3>
                      <div class="row mt-2 ml-1">
                        <p>
                          (Rev. August 2023)Department of the Treasury — Internal Revenue Service
                        </p>
                      </div>
                      <div class="row mt-2">
                        <div class="col-lg-8">
                          <p>Use this form if you want to request approval to have an agent file returns and make
                            deposits or payments of employment or other withholding taxes or if you want to
                            revoke an existing appointment. </p>
                          <p>• If you are an employer or payer who wants to request approval, complete Parts 1
                            and 2 and sign Part 2. Then give it to the agent. Have the agent complete Part 3 and
                            sign it. </p>
                          <p>
                            Note. This appointment is not effective until we approve your request. See the instructions
                            for filing Form 2678 on page 3.
                          </p>
                          <p>• If you are an employer, payer, or agent who wants to revoke an existing appointment,
                            complete all three parts. In this case, only one signature is required.</p>

                        </div>
                        <div class="col-lg-4">
                          <div class="row mb-2" style="height:150px">
                            <div class="col">
                              <div class="card ">

                                <div class="card-body">
                                  <div>
                                    <h5 style="background-color: black;color:white">For IRS Use</h5>
                                  </div>

                                </div>
                              </div>
                            </div>
                          </div>


                        </div>
                      </div>
                      <div class="row mb-2">
                        <div class="col">
                          <div class="card ">
                            <div class="card-header">
                              <h5><b>Part 1:</b>&nbsp;<b>Why you are filing this form...</b></h5>
                            </div>
                            <div class="card-body">
                              <div class="row">
                                <p>(Check one) </p>
                              </div>
                              <div class="row mt-2">
                                <div class="col-lg-1">
                                  <input type="radio" value="check1"
                                    [(ngModel)]="OnboardClientDocumentBO?.employerOrPayerAppointmentOfAgentDocumentBO.appointorRevoke"
                                    id="pre1" name="deposit">

                                </div>
                                <div class="col-lg-8">
                                  <label>You want to appoint an agent for tax reporting, depositing, and paying.
                                  </label>
                                </div>
                              </div>
                              <div class="row mt-2">
                                <div class="col-lg-1">
                                  <input type="radio" value="check2"
                                    [(ngModel)]="OnboardClientDocumentBO?.employerOrPayerAppointmentOfAgentDocumentBO.appointorRevoke"
                                    id="pre2" name="deposit">
                                </div>
                                <div class="col-lg-8">
                                  <label>You want to revoke an existing appointment. </label>
                                </div>
                              </div>

                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="row mb-2 mt-4">
                        <div class="col">
                          <div class="card ">
                            <div class="card-header">
                              <h5><b>Part 2:</b>&nbsp;<b>Employer or Payer Information: Complete this part if you want
                                  to
                                  appoint an agent or revoke an appointment</b></h5>
                            </div>
                            <div class="card-body" style="padding:35px;">
                              <div class="row mt-3">

                                <div class="col-lg-6">
                                  <label>1.&nbsp;Employer identification number (EIN) </label>
                                </div>
                                <div class="col-lg-6">
                                  <input type="text" class="form-control"
                                    [(ngModel)]="OnboardClientDocumentBO?.employerOrPayerAppointmentOfAgentDocumentBO.employeeIndentificationNumber">
                                </div>
                              </div>
                              <div class="row mt-3">

                                <div class="col-lg-6">
                                  <label>2.&nbsp;Employer’s or payer’s name
                                    (not your trade name)</label>
                                </div>
                                <div class="col-lg-6">
                                  <input type="text" class="form-control"
                                    [(ngModel)]="OnboardClientDocumentBO?.employerOrPayerAppointmentOfAgentDocumentBO.employersOrPayerName">
                                </div>
                              </div>
                              <div class="row mt-3">

                                <div class="col-lg-6">
                                  <label>3.&nbsp;Trade name (if any) </label>
                                </div>
                                <div class="col-lg-6">
                                  <input type="text" class="form-control"
                                    [(ngModel)]="OnboardClientDocumentBO?.employerOrPayerAppointmentOfAgentDocumentBO.tradeName">
                                </div>
                              </div>
                              <div class="row mt-3">

                                <div class="col-lg-6">
                                  <label>4.&nbsp;Address </label>
                                </div>
                                <div class="col-lg-6">
                                  <div class="row">
                                    <div class="col-lg-4"> <label>Number </label></div>

                                    <div class="col-lg-4"> <label>Street </label></div>

                                    <div class="col-lg-4"> <label>Suite or room number</label></div>

                                  </div>


                                  <textarea class="form-control"
                                    [(ngModel)]="OnboardClientDocumentBO?.employerOrPayerAppointmentOfAgentDocumentBO.suiteOrRoomNumber"></textarea>
                                </div>

                              </div>
                              <div class="row mt-2">

                                <div class="col-lg-12">
                                  <div class="row">
                                    <div class="col-lg-4">
                                      <label>City</label>
                                      <input type="text" class="form-control"
                                        [(ngModel)]="OnboardClientDocumentBO?.employerOrPayerAppointmentOfAgentDocumentBO.city">
                                    </div>
                                    <div class="col-lg-4">
                                      <label>State</label>
                                      <ng-select
                                        [(ngModel)]="OnboardClientDocumentBO?.employerOrPayerAppointmentOfAgentDocumentBO.state"
                                        [items]="stateList" class="width25" [searchable]="true" [clearable]="true"
                                        bindLabel="name" bindValue="abbreviation">
                                      </ng-select>
                                    </div>
                                    <div class="col-lg-4">
                                      <label>Zip Code</label>
                                      <input type="number" class="form-control"
                                        [(ngModel)]="OnboardClientDocumentBO?.employerOrPayerAppointmentOfAgentDocumentBO.zip">
                                    </div>
                                  </div>

                                </div>
                              </div>

                              <div style="margin-top: 20px;">
                                <table class="table-bordered table-responsive">
                                  <tr>

                                    <th style="width: 40%;"> <b>5.&nbsp;Forms for which you want to appoint an agent or
                                        revoke the agent’s
                                        appointment to file. </b>(Check all that apply.)</th>
                                    <th style="width:10%">For ALL
                                      employees/
                                      payees/payments</th>
                                    <th style="width:10%"> <b>For SOME
                                        employees/
                                        payees/payments</b></th>


                                  </tr>
                                  <tr>
                                    <td style="text-align:left;">Form 940, 940-PR (Employer's Annual Federal
                                      Unemployment
                                      (FUTA) Tax Return)*
                                    </td>
                                    <td style="text-align: center;"><input type="checkbox"
                                        [(ngModel)]="OnboardClientDocumentBO?.employerOrPayerAppointmentOfAgentDocumentBO.futaForAll">
                                    </td>
                                    <td style="text-align: center;"><input type="checkbox"
                                        [(ngModel)]="OnboardClientDocumentBO?.employerOrPayerAppointmentOfAgentDocumentBO.futaForSome">
                                    </td>
                                  </tr>

                                  <tr>
                                    <td style="text-align: left;">
                                      Form 943, 943-PR (Employer’s Annual Federal Tax Return for Agricultural Employees)
                                    </td>

                                    <td style="text-align: center;"><input type="checkbox"
                                        [(ngModel)]="OnboardClientDocumentBO?.employerOrPayerAppointmentOfAgentDocumentBO.employersQuarterlyFederalTaxForAll">
                                    </td>
                                    <td style="text-align: center;"><input type="checkbox"
                                        [(ngModel)]="OnboardClientDocumentBO?.employerOrPayerAppointmentOfAgentDocumentBO.employersQuarterlyFederalTaxForSome">
                                    </td>
                                  </tr>

                                  <tr>
                                    <td style="text-align: left;">Form 944, 944(SP) (Employer’s ANNUAL Federal Tax
                                      Return)
                                    </td>
                                    <td style="text-align: center;"><input type="checkbox"
                                        [(ngModel)]="OnboardClientDocumentBO?.employerOrPayerAppointmentOfAgentDocumentBO.employersAnnualFederalTaxReturnForAll">
                                    </td>
                                    <td style="text-align: center;"><input type="checkbox"
                                        [(ngModel)]="OnboardClientDocumentBO?.employerOrPayerAppointmentOfAgentDocumentBO.employersAnnualFederalTaxReturnForSome">
                                    </td>
                                  </tr>
                                  <tr>
                                    <td style="text-align:left;">Form 945 (Annual Return of Withheld Federal Income Tax)
                                    </td>
                                    <td style="text-align: center;"><input type="checkbox"
                                        [(ngModel)]="OnboardClientDocumentBO?.employerOrPayerAppointmentOfAgentDocumentBO.annualReturnofWithheldFederalIncomeTaxForAll">
                                    </td>
                                    <td style="text-align: center;"><input type="checkbox"
                                        [(ngModel)]="OnboardClientDocumentBO?.employerOrPayerAppointmentOfAgentDocumentBO.annualReturnofWithheldFederalIncomeTaxForSome">
                                    </td>
                                  </tr>
                                  <tr>
                                    <td style="text-align:left;">Form CT-1 (Employer’s Annual Railroad Retirement Tax
                                      Return)
                                    </td>
                                    <td style="text-align: center;"><input type="checkbox"
                                        [(ngModel)]="OnboardClientDocumentBO?.employerOrPayerAppointmentOfAgentDocumentBO.annualReturnofWithheldFederalIncomeTaxForAll">
                                    </td>
                                    <td style="text-align: center;"><input type="checkbox"
                                        [(ngModel)]="OnboardClientDocumentBO?.employerOrPayerAppointmentOfAgentDocumentBO.annualReturnofWithheldFederalIncomeTaxForSome">
                                    </td>
                                  </tr>
                                  <tr>
                                    <td style="text-align: left;">Form CT-2 (Employee Representative's Quarterly
                                      Railroad
                                      Tax Return)
                                    </td>
                                    <td style="text-align: center;"><input type="checkbox"
                                        [(ngModel)]="OnboardClientDocumentBO?.employerOrPayerAppointmentOfAgentDocumentBO.employersAnnualRailroadRetirementTaxReturnForAll">
                                    </td>
                                    <td style="text-align: center;"><input type="checkbox"
                                        [(ngModel)]="OnboardClientDocumentBO?.employerOrPayerAppointmentOfAgentDocumentBO.employersAnnualRailroadRetirementTaxReturnForSome">
                                    </td>
                                  </tr>



                                </table>
                              </div>
                              <div class="row mt-3 ml-2">
                                <p>*Generally you cannot appoint an agent to report, deposit, and pay tax reported on
                                  Form
                                  940, Employer's Annual Federal
                                  Unemployment (FUTA) Tax Return, unless you are a home care service recipient.</p>
                              </div>
                              <div class="row mt-2">
                                <div class="col-lg-1">
                                  <input type="checkbox"
                                    [(ngModel)]="OnboardClientDocumentBO?.employerOrPayerAppointmentOfAgentDocumentBO.ifyou_are_home_care_service_recipient">
                                </div>
                                <div class="col-lg-8">
                                  <label>Check here if you are a home care service recipient, and you want to appoint
                                    the
                                    agent to report, deposit, and pay FUTA
                                    tax for you. See the instructions</label>
                                </div>
                              </div>
                              <div class="row mt-2 ml-2">
                                <p>I am authorizing the IRS to disclose otherwise confidential tax information to the
                                  agent
                                  relating to the authority granted under this
                                  appointment, including disclosures required to process Form 2678. The agent may
                                  contract
                                  with a third party, such as a
                                  reporting agent or certified public accountant, to prepare or file the returns covered
                                  by
                                  this appointment, or to make any required
                                  deposits and payments. Such contract may authorize the IRS to disclose confidential
                                  tax
                                  information of the employer/payer and
                                  agent to such third party. If a third party fails to file the returns or make the
                                  deposits
                                  and payments, the agent and employer/
                                  payer remain liable.
                                </p>
                              </div>
                              <div class="row mt-2">
                                <div class="col-lg-6">

                                  <div class="row mt-5 ml-2">
                                    <div class="col-6">
                                      <button type="button" class="btn btn-primary" data-bs-toggle="modal"
                                        data-bs-target="#signid">
                                        Sign your
                                        name here
                                      </button> <sup class="super-script">&nbsp;*&nbsp;</sup>
                                    </div>
                                  </div>
                                  <div class="row mt-2 mb-2">
                                    <div> <label class="font-weight "> <img *ngIf="signhere1!=''&& signhere1!=null "
                                          src={{signhere1}} class="form-control mt-3 " style="width: 179px;height:80px;"
                                          alt="employeeSign" width="48" height="48" /></label>

                                    </div>
                                    <!-- <div class="col-lg-4">
                                          <input *ngIf="signhere1!=''&& signhere1!=null" type="image" src="{{signhere1}}"
                                            [(ngModel)]="OnboardClientDocumentBO?.employerOrPayerAppointmentOfAgentDocumentBO.signEmployerOrPayor" class="form-control" style="width: 255px;height:120px;"
                                            alt="nurse" width="48" height="48">
                                        </div> -->
                                  </div>

                                  <div class="row mt-5 ml-2">
                                    <div class="col-lg-1">
                                      <label for="cname">Date:<sup class="super-script">*&nbsp;</sup></label>
                                    </div>
                                    <div class="col-lg-5">
                                      <label>{{OnboardClientDocumentBO?.employerOrPayerAppointmentOfAgentDocumentBO.signDate}}</label>
                                      <!-- <my-date-picker class="w-100" [options]="myDatePickerOptionsDOB"
                                            placeholder="mm/dd/yyyy" [selDate]="OnboardClientDocumentBO?.employerOrPayerAppointmentOfAgentDocumentBO.signDateEmployerOrPayor"
                                           >
        
                                          </my-date-picker> -->
                                    </div>

                                  </div>
                                </div>




                                <div class="col-lg-6">
                                  <div class="row mt-2">
                                    <div class="col-lg-3"><label>Type</label></div>
                                    <div class="col-lg-8"><input type="text" class="form-control"
                                        [(ngModel)]="OnboardClientDocumentBO?.employerOrPayerAppointmentOfAgentDocumentBO.agentTypeName">
                                    </div>
                                  </div>

                                  <div class="row mt-2">
                                    <div class="col-lg-3"><label>Choose</label></div>
                                    <div class="col-lg-8">
                                      <ng-select [items]="selflist" class="width25" [searchable]="true"
                                        style="display:inline-block;width:150px;" [clearable]="true" bindLabel="Value"
                                        bindValue="Key" placeholder="Choose One"
                                        [(ngModel)]="OnboardClientDocumentBO?.employerOrPayerAppointmentOfAgentDocumentBO.titleName">
                                      </ng-select>
                                    </div>
                                  </div>

                                  <div class="row mt-2">
                                    <div class="col-lg-3"><label>Best daytime phone
                                      </label></div>
                                    <div class="col-lg-8"> <input type="text" class="form-control"
                                        [(ngModel)]="OnboardClientDocumentBO?.employerOrPayerAppointmentOfAgentDocumentBO.dayTimePhone">
                                    </div>


                                  </div>


                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="row mb-2 mt-4 mb-3">
                        <div class="col">
                          <div class="card ">
                            <div class="card-header">
                              <h5><b>Part 3:</b>&nbsp;<b>Agent Information: If you will be an agent for an employer or
                                  payer, or want to revoke an appointment, complete this part</b></h5>
                            </div>
                            <div class="card-body" style="padding:35px;">
                              <div class="row mt-3">

                                <div class="col-lg-6">
                                  <label>6.&nbsp;Agent's employer identification number (EIN)</label>
                                </div>
                                <div class="col-lg-6">
                                  <input type="text" class="form-control"
                                    [(ngModel)]="OnboardClientDocumentBO?.employerOrPayerAppointmentOfAgentDocumentBO.agentEmployerIndentificationNumber">
                                </div>
                              </div>
                              <div class="row mt-3">

                                <div class="col-lg-6">
                                  <label>7.&nbsp;Agent's name (not trade name)</label>
                                </div>
                                <div class="col-lg-6">
                                  <input type="text" class="form-control" [(ngModel)]="global.agencyName">
                                </div>
                                <!-- [(ngModel)]="OnboardClientDocumentBO?.employerOrPayerAppointmentOfAgentDocumentBO.agentsName"> -->

                              </div>
                              <div class="row mt-3">

                                <div class="col-lg-6">
                                  <label>8.&nbsp;Trade name (if any) </label>
                                </div>
                                <div class="col-lg-6">
                                  <input type="text" class="form-control"
                                    [(ngModel)]="OnboardClientDocumentBO?.employerOrPayerAppointmentOfAgentDocumentBO.agentTradeName">
                                </div>
                              </div>
                              <div class="row mt-3">

                                <div class="col-lg-6">
                                  <label>4.&nbsp;Address </label>
                                </div>
                                <div class="col-lg-6">
                                  <div class="row">
                                    <div class="col-lg-4"> <label>Number </label></div>

                                    <div class="col-lg-4"> <label>Street </label></div>

                                    <div class="col-lg-4"> <label>Suite or room number</label></div>

                                  </div>

                                  <textarea class="form-control"
                                    [(ngModel)]="OnboardClientDocumentBO?.employerOrPayerAppointmentOfAgentDocumentBO.agentSuiteOrRoomNumber"></textarea>
                                </div>
                              </div>
                              <div class="row mt-2">

                                <div class="col-lg-12">
                                  <div class="row">
                                    <div class="col-lg-4">
                                      <label>City</label>
                                      <input type="text" class="form-control"
                                        [(ngModel)]="OnboardClientDocumentBO?.employerOrPayerAppointmentOfAgentDocumentBO.agentCity">
                                    </div>
                                    <div class="col-lg-4">
                                      <label>State</label>
                                      <ng-select
                                        [(ngModel)]="OnboardClientDocumentBO?.employerOrPayerAppointmentOfAgentDocumentBO.agentState"
                                        [items]="stateList" class="width25" [searchable]="true" [clearable]="true"
                                        bindLabel="name" bindValue="abbreviation">
                                      </ng-select>
                                    </div>
                                    <div class="col-lg-4">
                                      <label>Zip Code</label>
                                      <input type="number" class="form-control"
                                        [(ngModel)]="OnboardClientDocumentBO?.employerOrPayerAppointmentOfAgentDocumentBO.agentZip">
                                    </div>
                                  </div>

                                </div>
                              </div>





                              <div class="row mt-2">
                                <div class="col-lg-1">
                                  <input type="checkbox"
                                    [(ngModel)]="OnboardClientDocumentBO?.employerOrPayerAppointmentOfAgentDocumentBO.ifyou_are_home_care_service_recipient">
                                </div>
                                <div class="col-lg-8">
                                  <label>Check here if the employer is a home care service recipient receiving home care
                                    services through a program administered by a
                                    federal, state, or local government agency</label>
                                </div>
                              </div>
                              <div class="row mt-3 ml-2">
                                <p>Under penalties of perjury, I declare that I have examined this form and any
                                  attachments,
                                  and to the best of my knowledge and belief, it
                                  is true, correct, and complete. </p>
                              </div>

                              <div class="row mt-2">
                                <div class="col-lg-6">

                                  <div class="row mt-5 ml-2">
                                    <div class="col-6">
                                      <button type="button" class="btn btn-primary" data-bs-toggle="modal"
                                        data-bs-target="#signhere2">
                                        Sign your
                                        name here
                                      </button> <sup class="super-script">&nbsp;*&nbsp;</sup>
                                    </div>
                                  </div>
                                  <div class="row mt-2 mb-2">

                                    <div> <label class="font-weight "> <img *ngIf="signhere2!=''&& signhere2!=null "
                                          src={{signhere2}} class="form-control mt-3 " style="width: 179px;height:80px;"
                                          alt="employeeSign" width="48" height="48" /></label>

                                    </div>

                                  </div>

                                  <div class="row mt-5 ml-2">
                                    <div class="col-lg-1">
                                      <label for="cname">Date:<sup class="super-script">*&nbsp;</sup></label>
                                    </div>
                                    <div class="col-lg-5">
                                      <label>{{OnboardClientDocumentBO?.employerOrPayerAppointmentOfAgentDocumentBO.agentSignDate}}</label>
                                      <!-- <my-date-picker class="w-100" [options]="myDatePickerOptionsDOB" [selDate]="OnboardClientDocumentBO?.employerOrPayerAppointmentOfAgentDocumentBO.agenctSignDate"
                                            placeholder="mm/dd/yyyy"
                                          >
        
                                          </my-date-picker> -->
                                    </div>

                                  </div>
                                </div>




                                <div class="col-lg-6">
                                  <div class="row mt-2">
                                    <div class="col-lg-3"><label>Choose your Name Here</label></div>
                                    <div class="col-lg-8"><input type="text" class="form-control"
                                        [(ngModel)]="OnboardClientDocumentBO?.employerOrPayerAppointmentOfAgentDocumentBO.agentTypeName">
                                    </div>
                                  </div>

                                  <div class="row mt-2">
                                    <div class="col-lg-3"><label>Choose your Title Here</label></div>
                                    <div class="col-lg-8"> <ng-select [items]="selflist" class="width25"
                                        [searchable]="true" style="display:inline-block;width:150px;" [clearable]="true"
                                        bindLabel="Value" bindValue="Key" placeholder="Choose One"
                                        [(ngModel)]="OnboardClientDocumentBO?.employerOrPayerAppointmentOfAgentDocumentBO.titleName">
                                      </ng-select>

                                      <!-- [(ngModel)]="OnboardClientDocumentBO?.employerOrPayerAppointmentOfAgentDocumentBO.titleLid"> -->
                                    </div>
                                  </div>

                                  <div class="row mt-2">
                                    <div class="col-lg-3"><label>Best daytime phone
                                      </label></div>
                                    <div class="col-lg-8"> <input type="text" class="form-control"
                                        [(ngModel)]="OnboardClientDocumentBO?.employerOrPayerAppointmentOfAgentDocumentBO.agentDayTimePhone">
                                    </div>


                                  </div>


                                </div>
                              </div>


                            </div>
                          </div>
                        </div>
                      </div>



                    </div>
                    <div class="card-footer">
                      <div class="row">

                        <!-- <div class="col text-right mb-3 mt-3">
                          
                          <button type="button"  class="btn blue-btn mr-3"  (click)="save()" [disabled]="OnboardClientDocumentBO?.employerOrPayerAppointmentOfAgentDocumentBO.signDateEmployerOrPayor==''||OnboardClientDocumentBO?.employerOrPayerAppointmentOfAgentDocumentBO.signDateEmployerOrPayor==undefined||OnboardClientDocumentBO?.employerOrPayerAppointmentOfAgentDocumentBO.signDateEmployerOrPayor==null || OnboardClientDocumentBO?.employerOrPayerAppointmentOfAgentDocumentBO.agenctSignDate==''||OnboardClientDocumentBO?.employerOrPayerAppointmentOfAgentDocumentBO.agenctSignDate==undefined||OnboardClientDocumentBO?.employerOrPayerAppointmentOfAgentDocumentBO.agenctSignDate==null || signhere2==null || signhere2==''||signhere2==undefined ||signhere1==''||signhere1==undefined||signhere1==null" class="btn blue-btn"
                           >Save</button>
                          <button type="button" class="btn blue-btn" *ngIf="isUpdate && !clientonboardBO.edit">Update
                          
                          </button>
                          <button type="button" class="btn blue-btn ml-3" data-bs-dismiss="modal">Clear</button>
                        </div> -->

                      </div>
                    </div>
                  </div>
                </div>
              </div>



              <div class="row mb-4 mt-4">
                <div class="col">
                  <div class="card ">
                    <div class="card-body" style="padding:65px;">

                      <div class="row mt-2">
                        <div class="col-10">
                          <img src="..\assets\img\indivual.JPG" class="img-fluid" alt="Responsive image">
                        </div>
                      </div>
                      <div class="row mt-2 ml-2">
                        <p><b>Read Instructions before completing this form.To grant authority for a business,complete
                            form
                            REV184b,Business Power of Attorney</b></p>
                      </div>
                      <div class="row mt-2 mb-3">
                        <div class="col">
                          <div class="row">
                            <div class="col-1">
                              <img src="..\assets\img\taxpayer.JPG" class="img-fluid" alt="Responsive image"
                                style="text-align:center;">
                            </div>



                            <div class="col-11">
                              <div class="row mt-2">
                                <div class="col-6">
                                  <label>Taxpayer Name</label>

                                  <input type="text" class="form-control"
                                    [(ngModel)]="OnboardClientDocumentBO?.individual_Sole_Proprietor_OfAttornyDocumentBO.taxpayerName">
                                  <label>Street Address or PO Box
                                  </label>
                                  <textarea class="form-control"
                                    [(ngModel)]="OnboardClientDocumentBO?.individual_Sole_Proprietor_OfAttornyDocumentBO.street_Addres_or_PoBox"></textarea>


                                </div>
                                <div class="col-6">
                                  <label>Social Security Number or ITIN</label>

                                  <input type="text" class="form-control"
                                    [(ngModel)]="OnboardClientDocumentBO?.individual_Sole_Proprietor_OfAttornyDocumentBO.social_Security_number_or_Itin"
                                    minlength="9" maxlength="9">
                                  <label>Minnesota or Federal Employer Identification Number (FEIN) (Sole
                                    proprietors)</label>
                                  <input type="text" class="form-control"
                                    [(ngModel)]="OnboardClientDocumentBO?.individual_Sole_Proprietor_OfAttornyDocumentBO.minnesota_or_Federal_Employer_Identification_Number">

                                </div>
                              </div>
                              <div class="row mt-2">
                                <div class="col-lg-4">
                                  <label>Apt or Suite
                                  </label>
                                  <input type="text" class="form-control"
                                    [(ngModel)]="OnboardClientDocumentBO?.individual_Sole_Proprietor_OfAttornyDocumentBO.apt_or_Suit">
                                </div>
                                <div class="col-lg-4">
                                  <label>Phone Number </label>
                                  <input type="indiphn" class="form-control"
                                    [(ngModel)]="OnboardClientDocumentBO?.individual_Sole_Proprietor_OfAttornyDocumentBO.phoneNumber">
                                </div>
                                <div class="col-lg-4">
                                  <label>Fax Number </label>
                                  <input type="indifax" class="form-control"
                                    [(ngModel)]="OnboardClientDocumentBO?.individual_Sole_Proprietor_OfAttornyDocumentBO.faxNumber">
                                </div>
                              </div>
                              <div class="row mt-2">

                                <div class="col-4">
                                  <label>City
                                  </label>
                                  <input type="text" class="form-control"
                                    [(ngModel)]="OnboardClientDocumentBO?.individual_Sole_Proprietor_OfAttornyDocumentBO.city">
                                </div>
                                <div class="col-4">
                                  <label>State </label>

                                  <ng-select
                                    [(ngModel)]="OnboardClientDocumentBO?.individual_Sole_Proprietor_OfAttornyDocumentBO.state"
                                    [items]="stateList" class="width25" [searchable]="true" [clearable]="true"
                                    bindLabel="name" bindValue="abbreviation">
                                  </ng-select>
                                </div>
                                <div class="col-4">
                                  <label>Zip Code </label>
                                  <input type="number" class="form-control"
                                    [(ngModel)]="OnboardClientDocumentBO?.individual_Sole_Proprietor_OfAttornyDocumentBO.zipCode">

                                </div>

                              </div>
                              <div class="row mt-2">
                                <div class="col-7">
                                  <label>Email Address </label>

                                  <input type="text" class="form-control"
                                    [(ngModel)]="OnboardClientDocumentBO?.individual_Sole_Proprietor_OfAttornyDocumentBO.emailAddress">


                                </div>
                              </div>
                            </div>
                          </div>


                        </div>
                      </div>

                      <div class="row mt-2 mb-3">
                        <div class="col">
                          <div class="row">
                            <div class="col-1">
                              <img src="..\assets\img\second.JPG" class="img-fluid" alt="Responsive image"
                                style="text-align:center;">
                            </div>


                            <div class="col-11">
                              <div class="row mt-2">
                                <div class="col-6">
                                  <label>Name of Appointee</label>

                                  <input type="text" class="form-control"
                                    [(ngModel)]="OnboardClientDocumentBO?.individual_Sole_Proprietor_OfAttornyDocumentBO.name_of_Appointee">
                                  <label>Street Address or PO Box
                                  </label>
                                  <textarea class="form-control"
                                    [(ngModel)]="OnboardClientDocumentBO?.individual_Sole_Proprietor_OfAttornyDocumentBO.primary_Appointee_Street_Address_or_PoBox"></textarea>


                                </div>
                                <div class="col-6">
                                  <label>Attorney Number,Accountant Number or PTIN</label>

                                  <input type="text" class="form-control"
                                    [(ngModel)]="OnboardClientDocumentBO?.individual_Sole_Proprietor_OfAttornyDocumentBO.primary_Appointee_Attorney_Number_Accountant_Number_or_Ptin">

                                  <label>Phone Number</label>
                                  <input type="text" class="form-control" [(ngModel)]="OnboardClientDocumentBO?.individual_Sole_Proprietor_OfAttornyDocumentBO.primary_Appointee_PhoneNumber

                                    ">

                                </div>
                              </div>
                              <div class="row mt-2">
                                <div class="col-lg-6">
                                  <label>Apt or Suite
                                  </label>
                                  <input type="text" class="form-control"
                                    [(ngModel)]="OnboardClientDocumentBO?.individual_Sole_Proprietor_OfAttornyDocumentBO.primary_Appointee_Apt_or_Suite">
                                </div>

                                <div class="col-lg-6">
                                  <label>Fax Number</label>
                                  <input type="text" class="form-control"
                                    [(ngModel)]="OnboardClientDocumentBO?.individual_Sole_Proprietor_OfAttornyDocumentBO.primary_Appointee_FaxNumber">
                                </div>
                              </div>
                              <div class="row mt-2">

                                <div class="col-3">
                                  <label>City
                                  </label>
                                  <input type="text" class="form-control"
                                    [(ngModel)]="OnboardClientDocumentBO?.individual_Sole_Proprietor_OfAttornyDocumentBO.primary_Appointee_city">
                                </div>
                                <div class="col-2">
                                  <label>State</label>

                                  <ng-select
                                    [(ngModel)]="OnboardClientDocumentBO?.individual_Sole_Proprietor_OfAttornyDocumentBO.primary_Appointee_state"
                                    [items]="stateList" class="width25" [searchable]="true" [clearable]="true"
                                    bindLabel="name" bindValue="abbreviation"></ng-select>
                                </div>
                                <div class="col-2">
                                  <label>Zip Code</label>
                                  <input type="number" class="form-control"
                                    [(ngModel)]="OnboardClientDocumentBO?.individual_Sole_Proprietor_OfAttornyDocumentBO.primary_Appointee_Zipcode">

                                </div>
                                <div class="col-5">
                                  <label>Email Address</label>

                                  <input type="text" class="form-control"
                                    [(ngModel)]="OnboardClientDocumentBO?.individual_Sole_Proprietor_OfAttornyDocumentBO.primary_Appointee_EmailAddress">


                                </div>
                              </div>
                            </div>
                          </div>


                        </div>
                      </div>
                      <p>If Appointing more than one person enter on page 2 of this form</p>

                      <div class="row mt-2 mb-3">
                        <div class="col">
                          <div class="card ">
                            <div class="card-body" style="padding:25px;">
                              <div class="row">
                                <div class="col-1">
                                  <img src="..\assets\img\third.JPG" class="img-fluid" alt="Responsive image"
                                    style="text-align:center;">
                                </div>

                                <div class="col-11">
                                  <div class="row mt-2" style="padding-left:20px;">
                                    <p>I appoint the person above and anyone included on the attached list,to access my
                                      information and represent me before the Minnesota department of Revenue.This
                                      authority
                                      does not cover powers listed in the additional powers section below unless
                                      indicated
                                    </p>
                                    <p>check the box for <b>Limited Authority</b> or <b>Full Authority</b></p>
                                    <div class="col-lg-9">
                                      <div class="row">
                                        <table class="table table-bordered table-responsive">
                                          <thead>
                                            <!-- <tr> -->
                                            <div class="row ml-2" id="radi">
                                              <div class="col-1">
                                                <input type="radio" name="radiobtn" value="limit"
                                                  [(ngModel)]="OnboardClientDocumentBO.individual_Sole_Proprietor_OfAttornyDocumentBO.lLmitedAthourity">
                                              </div>
                                              <div class="col-5">
                                                <label><b>Limited Authority</b></label>
                                              </div>
                                            </div>

                                            <div class="row">
                                              <div class="col-lg-12">
                                                <p>The Appointee is authorized to act on behalf but only for the
                                                  following
                                                </p>

                                              </div>
                                            </div>

                                            <div class="row">
                                              <div class="col-lg-9">
                                                <p>Type Of Tax(such as income Estate,Property Tax Refund,Withholding)or
                                                  Dept
                                                  issue</p>
                                              </div>

                                              <div class="col-lg-3" style="text-align: right;">
                                                <label style="text-align: right;">Years or Periods</label>
                                                <p style="text-align: right;">if Left blanks applies to all</p>
                                              </div>
                                            </div>
                                            <!-- </tr> -->
                                          </thead>
                                          <tbody>
                                            <tr>

                                              <td><label>Withholding Tax</label></td>
                                              <td><input type="text" class="form-control"
                                                  [disabled]="clientonboardBO?.datalist?.onboardStatusLidName == 'SUBMITTED' "
                                                  [(ngModel)]="OnboardClientDocumentBO?.individual_Sole_Proprietor_OfAttornyDocumentBO.years_of_Periods1">
                                              </td>


                                            </tr>
                                            <tr>

                                              <td><input type="text" class="form-control"
                                                  [disabled]="clientonboardBO?.datalist?.onboardStatusLidName == 'SUBMITTED' "
                                                  [(ngModel)]="OnboardClientDocumentBO?.individual_Sole_Proprietor_OfAttornyDocumentBO.authority_Granted_Type_of_Tax1">
                                              </td>
                                              <td><input type="text" class="form-control"
                                                  [disabled]="clientonboardBO?.datalist?.onboardStatusLidName == 'SUBMITTED' "
                                                  [(ngModel)]="OnboardClientDocumentBO?.individual_Sole_Proprietor_OfAttornyDocumentBO.years_of_Periods2">
                                              </td>


                                            </tr>
                                            <tr>
                                              <td><input type="text" class="form-control"
                                                  [disabled]="clientonboardBO?.datalist?.onboardStatusLidName == 'SUBMITTED' "
                                                  [(ngModel)]="OnboardClientDocumentBO?.individual_Sole_Proprietor_OfAttornyDocumentBO.authority_Granted_Type_of_Tax2">
                                              </td>
                                              <td><input type="text" class="form-control"
                                                  [disabled]="clientonboardBO?.datalist?.onboardStatusLidName == 'SUBMITTED' "
                                                  [(ngModel)]="OnboardClientDocumentBO?.individual_Sole_Proprietor_OfAttornyDocumentBO.years_of_Periods3">
                                              </td>
                                            </tr>
                                            <tr>
                                              <td><input type="text" class="form-control"
                                                  [disabled]="clientonboardBO?.datalist?.onboardStatusLidName == 'SUBMITTED' "
                                                  [(ngModel)]="OnboardClientDocumentBO?.individual_Sole_Proprietor_OfAttornyDocumentBO.authority_Granted_Type_of_Tax3">
                                              </td>
                                              <td><input type="text" class="form-control"
                                                  [disabled]="clientonboardBO?.datalist?.onboardStatusLidName == 'SUBMITTED' "
                                                  [(ngModel)]="OnboardClientDocumentBO?.individual_Sole_Proprietor_OfAttornyDocumentBO.years_of_Periods4">
                                              </td>
                                            </tr>
                                          </tbody>
                                        </table>

                                        <!-- <table class="table table-bordered table-responsive">
                                  <thead>
                                    <tr>
                                      <div class="row ml-2" >
                                        <div class="col-1">
                                         
                                            <label></label>
                                        </div>
                                        <div class="col-5">
                                          <label><b>Limited Authority</b></label>
                                        </div>
                                      </div>
        
                                      <div class="row">
                                        <div class="col-lg-12">
                                          <p>The Appointee is authorized to act on behalf but only for the following
                                          </p>
        
                                        </div>
                                      </div>
        
                                      <div class="row">
                                        <div class="col-lg-9">
                                          <p>Type Of Tax(such as income Estate,Property Tax Refund,Withholding)or Dept
                                            issue</p>
                                        </div>
        
                                        <div class="col-lg-3" style="text-align: right;">
                                          <label style="text-align: right;">Years or Periods</label>
                                          <p style="text-align: right;">if Left blanks applies to all</p>
                                        </div>
                                      </div>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    <tr>
        
                                      <td><label>Withholding Tax</label></td>
                                      <td>{{OnboardClientDocumentBO?.individual_Sole_Proprietor_OfAttornyDocumentBO.years_of_Periods1}}</td>
                                      
        
                                    </tr>
                                    <tr>
        
                                      <td>{{OnboardClientDocumentBO?.individual_Sole_Proprietor_OfAttornyDocumentBO.authority_Granted_Type_of_Tax1}}</td>
                                          <td>{{OnboardClientDocumentBO?.individual_Sole_Proprietor_OfAttornyDocumentBO.years_of_Periods2}}</td>
                                       
        
                                    </tr>
                                    <tr>
                                      <td>{{OnboardClientDocumentBO?.individual_Sole_Proprietor_OfAttornyDocumentBO.authority_Granted_Type_of_Tax2}}</td>
                                       <td>{{OnboardClientDocumentBO?.individual_Sole_Proprietor_OfAttornyDocumentBO.years_of_Periods3}}</td>
                                         </tr>
                                    <tr>
                                      <td>{{OnboardClientDocumentBO?.individual_Sole_Proprietor_OfAttornyDocumentBO.authority_Granted_Type_of_Tax3}}</td>
                                       <td>{{OnboardClientDocumentBO?.individual_Sole_Proprietor_OfAttornyDocumentBO.years_of_Periods4}}</td>
                                         </tr>
                                  </tbody>
                                </table> -->

                                      </div>

                                    </div>
                                    <div class="col-lg-3">
                                      <div class="row">

                                        <div class="card">
                                          <div class="card-body">

                                            <div class="row ml-2" id="radi">
                                              <div class="col-1">
                                                <input type="radio" name="radiobtn" value="full"
                                                  [(ngModel)]="OnboardClientDocumentBO.individual_Sole_Proprietor_OfAttornyDocumentBO.lLmitedAthourity">
                                              </div>
                                              <div class="col-8">
                                                <label><b>Full Authority</b></label>
                                              </div>
                                            </div>
                                            <p class="card-text">this appointee is authorized to act on my behalf but
                                              only
                                              for all of my tax and debt issues for all years or periods</p>

                                          </div>
                                        </div>

                                      </div>

                                    </div>


                                  </div>
                                  <div class="row mt-2 ml-3">
                                    <div class="col-lg-5">
                                      <label>Authority Experiation Date
                                      </label><sup class="super-script">&nbsp;*&nbsp;</sup>
                                    </div>
                                    <div class="col-lg-4">
                                      <label>{{OnboardClientDocumentBO?.individual_Sole_Proprietor_OfAttornyDocumentBO.authority_Experiation_Date}}</label>
                                      <!-- <my-date-picker class="w-100" [options]="myDatePickerOptionsDOB"
                                [selDate]="OnboardClientDocumentBO?.individual_Sole_Proprietor_OfAttornyDocumentBO.authority_Experiation_Date" placeholder="mm/dd/yyyy"
                               >
        
                              </my-date-picker> -->
                                    </div>
                                  </div>


                                </div>
                              </div>


                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="row mt-2 mb-3">
                        <div class="col">
                          <div class="card ">
                            <div class="card-body" style="padding:25px;">

                              <div class="row">
                                <div class="col-1">
                                  <img src="..\assets\img\addpower.JPG" class="img-fluid" alt="Responsive image"
                                    style="text-align:center;">
                                </div>


                                <div class="col-10">
                                  <div class="row mt-2">
                                    <p>Add the following powers to the appointees limited or full authority (check any
                                      that
                                      apply)</p>
                                  </div>
                                  <div class="row mt-2">

                                    <div class="col-lg-1">
                                      <input type="checkbox"
                                        [(ngModel)]="OnboardClientDocumentBO?.individual_Sole_Proprietor_OfAttornyDocumentBO.communicate_with_the_department_by_email">
                                    </div>
                                    <div class="col-lg-5">
                                      <label>Communicate with the department by email</label>
                                    </div>
                                    <div class="col-lg-1">
                                      <input type="checkbox"
                                        [(ngModel)]="OnboardClientDocumentBO?.individual_Sole_Proprietor_OfAttornyDocumentBO.add_additional_appointees">
                                    </div>
                                    <div class="col-lg-5">
                                      <label>Add additional appointees(primary Appointee only)</label>
                                    </div>
                                  </div>
                                  <div class="row mt-2">
                                    <div class="col-lg-1">
                                      <input type="checkbox"
                                        [(ngModel)]="OnboardClientDocumentBO?.individual_Sole_Proprietor_OfAttornyDocumentBO.sign_returns_and_other_tax_forms">
                                    </div>
                                    <div class="col-lg-5">
                                      <label>sign returns and other tax forms</label>
                                    </div>
                                    <div class="col-lg-1">
                                      <input type="checkbox"
                                        [(ngModel)]="OnboardClientDocumentBO?.individual_Sole_Proprietor_OfAttornyDocumentBO.receive_all_mail_except_refunds">
                                    </div>
                                    <div class="col-lg-5">
                                      <label>Receive all mail except refunds(see instructions)(primary Appointee
                                        only)</label>
                                    </div>
                                  </div>
                                  <div class="row mt-2">
                                    <div class="col-lg-1">
                                      <input type="checkbox"
                                        [(ngModel)]="OnboardClientDocumentBO?.individual_Sole_Proprietor_OfAttornyDocumentBO.extend_statute_of_limitations_to_assess_tax">
                                    </div>
                                    <div class="col-lg-5">
                                      <label>Extend statute of limitations to assess tax</label>
                                    </div>
                                    <div class="col-lg-1">
                                      <input type="checkbox"
                                        [(ngModel)]="OnboardClientDocumentBO?.individual_Sole_Proprietor_OfAttornyDocumentBO.authorize_the_department_to_release_return_information_third_parties">
                                    </div>
                                    <div class="col-lg-5">
                                      <label>Authorize the department to release my return information to third
                                        parties</label>
                                    </div>
                                  </div>
                                  <div class="row mt-2">
                                    <div class="col-lg-1">
                                      <input type="checkbox"
                                        [(ngModel)]="OnboardClientDocumentBO?.individual_Sole_Proprietor_OfAttornyDocumentBO.excute_Agreements">
                                    </div>
                                    <div class="col-lg-5">
                                      <label>Excute Agreements</label>
                                    </div>
                                    <div class="col-lg-1">
                                      <input type="checkbox"
                                        [(ngModel)]="OnboardClientDocumentBO?.individual_Sole_Proprietor_OfAttornyDocumentBO.act_on_my_behalf_i_became_incapacitated_or_incompetent">
                                    </div>
                                    <div class="col-lg-5">
                                      <label>Act on my behalf if i became incapacitated or incompetent(Durable
                                        POA)</label>
                                    </div>
                                  </div>



                                </div>
                              </div>


                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="row mt-2 mb-3">
                        <div class="col">
                          <div class="card ">
                            <div class="card-body" style="padding:25px;">
                              <div class="row">
                                <div class="col-1">
                                  <img src="..\assets\img\signature.jpg" class="img-fluid" alt="Responsive image"
                                    style="text-align:center;">
                                </div>


                                <div class="col-10">
                                  <div class="row mt-2">
                                    <p>This power of Attorney is not valid until it is signed and dated by the Taxpayer
                                    </p>
                                    <p>parent,Gurdian,conservation i certify that i have the legal authority to sign
                                      this
                                      form</p>
                                  </div>

                                  <div class="row">
                                    <div class="col-2">
                                      <button type="button" class="btn btn-primary" data-bs-toggle="modal"
                                        data-bs-target="#power">
                                        Signature
                                      </button> <sup class="super-script">&nbsp;*&nbsp;</sup>
                                    </div>
                                    <div class="col-lg-1">
                                      <label for="cname">Date:<sup class="super-script">*&nbsp;</sup></label>
                                    </div>
                                    <div class="col-lg-2">
                                      <label>{{OnboardClientDocumentBO?.individual_Sole_Proprietor_OfAttornyDocumentBO.signatureDate}}</label>
                                      <!-- <my-date-picker class="w-100" [selDate]="OnboardClientDocumentBO?.individual_Sole_Proprietor_OfAttornyDocumentBO.date"
                                [options]="myDatePickerOptionsDOB" placeholder="mm/dd/yyyy"
                               >
        
                              </my-date-picker> -->
                                    </div>
                                    <div class="col-lg-3">
                                      <label>Address If Different from Taxpayer</label>
                                    </div>
                                    <div class="col-lg-3">
                                      <textarea class="form-control"
                                        [(ngModel)]="OnboardClientDocumentBO?.individual_Sole_Proprietor_OfAttornyDocumentBO.address_If_Different_from_Taxpayer"></textarea>
                                    </div>
                                  </div>
                                  <div class="row mt-2 mb-2">

                                    <div> <label class="font-weight "> <img *ngIf="Partisign!=''&& Partisign!=null "
                                          src={{Partisign}} class="form-control mt-3 " style="width: 179px;height:80px;"
                                          alt="employeeSign" width="48" height="48" /></label>

                                    </div>

                                  </div>

                                  <p>Print Name and If applicable</p>
                                  <div class="row mt-2">
                                    <div class="col-lg-12">
                                      <div class="row">
                                        <div class="col-lg-6">
                                          <input type="text" class="form-control"
                                            [(ngModel)]="OnboardClientDocumentBO?.individual_Sole_Proprietor_OfAttornyDocumentBO.print_Name_and_If_applicable">
                                        </div>
                                        <div class="col-lg-6">

                                          <ng-select [items]="selflist" class="width25" [searchable]="true"
                                            style="display:inline-block;width:150px;" [clearable]="true"
                                            bindLabel="Value" bindValue="Key" placeholder="Choose One"
                                            [(ngModel)]="OnboardClientDocumentBO?.individual_Sole_Proprietor_OfAttornyDocumentBO.chooseTitleLid">
                                          </ng-select>
                                        </div>
                                      </div>


                                    </div>




                                  </div>
                                  <div class="row">
                                    <div class="col-lg-12">
                                      <div class="row">
                                        <div class="col-lg-4">
                                          <label>Phone Number</label>
                                        </div>
                                        <div class="col-lg-6">

                                          <label>{{OnboardClientDocumentBO?.individual_Sole_Proprietor_OfAttornyDocumentBO.phoneNumber1}}</label>
                                          <input type="text" class="form-control"
                                            [(ngModel)]="OnboardClientDocumentBO?.individual_Sole_Proprietor_OfAttornyDocumentBO.signPhoneNumber">


                                        </div>
                                      </div>


                                    </div>
                                  </div>
                                  <div class="row mt-2">
                                    <div class="col-4">
                                      <label>City
                                      </label>
                                      <input type="text" class="form-control"
                                        [(ngModel)]="OnboardClientDocumentBO?.individual_Sole_Proprietor_OfAttornyDocumentBO.signature_City">
                                    </div>
                                    <div class="col-4">
                                      <label>State</label>

                                      <ng-select
                                        [(ngModel)]="OnboardClientDocumentBO?.individual_Sole_Proprietor_OfAttornyDocumentBO.signature_State"
                                        [items]="stateList" class="width25" [searchable]="true" [clearable]="true"
                                        bindLabel="name" bindValue="abbreviation">
                                      </ng-select>
                                    </div>
                                    <div class="col-4">
                                      <label>Zip Code</label>
                                      <input type="number" class="form-control"
                                        [(ngModel)]="OnboardClientDocumentBO?.individual_Sole_Proprietor_OfAttornyDocumentBO.signature_Zipcode">
                                    </div>
                                  </div>
                                </div>
                              </div>


                            </div>
                          </div>
                        </div>
                      </div>

                      <div class="row ml-2">
                        <p><b>Send a signed copy of this form to the Deportment</b></p>
                      </div>
                      <div class="row ml-2">
                        <p><b>Mail: &nbsp;&nbsp;Minnesota Deportment Of Revenue,Mail Station 4123,600N,Robert
                            st.,st.Paul,MN
                            55146</b></p>
                      </div>
                      <div class="row ml-2">
                        <p><b>FAX:&nbsp;&nbsp;651-556-5210</b></p>
                      </div>
                      <div class="row ml-2">
                        <p><b>Email&nbsp;&nbsp;:MNDOR,POA@State.mn.us</b></p>
                      </div>

                      <div class="row mt-4">
                        <div class="col-lg-12" style="text-align:center">
                          <h4><b>Additional Appointees</b></h4>
                        </div>

                      </div>

                      <div class="row mt-3">
                        <div class="col-lg-6">
                          <label>Name of Taxpayer</label>
                          <input type="text" class="form-control"
                            [(ngModel)]="OnboardClientDocumentBO?.individual_Sole_Proprietor_OfAttornyDocumentBO.additional_appointee_Form1_Name_of_Taxpayer">
                        </div>
                        <div class="col-lg-6">
                          <label>SSN,ITIN,MN ID,or FEIN</label>
                          <input type="text" class="form-control"
                            [(ngModel)]="OnboardClientDocumentBO?.individual_Sole_Proprietor_OfAttornyDocumentBO.additional_appointee_Form1_SsN_Itin_Mn_Id_or_Fein"
                            minlength="9" maxlength="9">
                        </div>
                      </div>

                      <div class="row mt-2 ml-2">
                        <p>include any appointees below Additional appointees only have authority over matters choose in
                          the
                          Authority Grantedd and Additional powers section on page 1.</p>
                      </div>

                      <div class="row mt-2 mb-3"
                        *ngIf="OnboardClientDocumentBO != null && OnboardClientDocumentBO !=undefined">
                        <div id="goalaccordion" class="col-lg-12"
                          *ngFor="let item of  OnboardClientDocumentBO.individual_Sole_Proprietor_OfAttornyDocumentBO.additional_appointeeAddress;let goal1=index">
                          <div class="col">
                            <div class="card ">

                              <div class="card-body" style="padding:25px;">

                                <div class="row">
                                  <div class="col-lg-10">
                                    <a style="color:#004290" data-bs-toggle="collapse"
                                      attr.data-bs-target="#collapse_{{goal1}}">

                                    </a>
                                  </div>

                                </div>
                                <div class="row">
                                  <div class="col-lg-12">
                                    <div class="row mt-2">
                                      <div class="col-6">
                                        <label>Name of Appointee</label>

                                        <input type="text" class="form-control" [(ngModel)]="item.nameofAppointee">
                                        <label>Street Address or PO Box
                                        </label>
                                        <textarea class="form-control"
                                          [(ngModel)]="item.street_Address_or_PoBox"></textarea>


                                      </div>
                                      <div class="col-6">
                                        <label>Attorney Number,Accountant Number or PTIN</label>

                                        <input type="text" class="form-control"
                                          [(ngModel)]="item.attorneyNumber_AccountantNumber_or_Ptin">
                                        <label>Phone Number</label>
                                        <input type="text" class="form-control" [(ngModel)]="item.phoneNumber"
                                          minlength="14" maxlength="14">

                                      </div>
                                    </div>
                                    <div class="row mt-2">
                                      <div class="col-lg-6">
                                        <label>Apt or Suite
                                        </label>
                                        <input type="text" class="form-control" [(ngModel)]="item.apt_or_Suite">
                                      </div>

                                      <div class="col-lg-6">
                                        <label>Fax Number</label>
                                        <input type="text" class="form-control" [(ngModel)]="item.faxNumber">
                                      </div>
                                    </div>
                                    <div class="row mt-2">

                                      <div class="col-4">
                                        <label>City
                                        </label>
                                        <input type="text" class="form-control" [(ngModel)]="item.city">
                                      </div>
                                      <div class="col-4">
                                        <label>State</label>

                                        <ng-select [(ngModel)]="item.state" [items]="stateList" class="width25"
                                          [searchable]="true" [clearable]="true" bindLabel="name"
                                          bindValue="abbreviation"></ng-select>
                                      </div>
                                      <div class="col-4">
                                        <label>Zip Code</label>
                                        <input type="number" class="form-control" [(ngModel)]="item.zip">

                                      </div>

                                    </div>
                                    <div class="row mt-1">
                                      <div class="col-7">
                                        <label>Email Address</label>

                                        <input type="text" class="form-control" [(ngModel)]="item.email">


                                      </div>
                                    </div>

                                  </div>

                                </div>


                              </div>
                            </div>
                          </div>
                        </div>




                      </div>
                    </div>

                    <div class="card-footer">
                      <div class="row">

                        <!-- <div class="col text-right mb-3 mt-3">
                          
                          <button type="button"  class="btn blue-btn mr-3"  (click)="save()" [disabled]="OnboardClientDocumentBO?.individual_Sole_Proprietor_OfAttornyDocumentBO.authority_Experiation_Date==''||OnboardClientDocumentBO?.individual_Sole_Proprietor_OfAttornyDocumentBO.authority_Experiation_Date==undefined||OnboardClientDocumentBO?.individual_Sole_Proprietor_OfAttornyDocumentBO.authority_Experiation_Date==null || OnboardClientDocumentBO?.individual_Sole_Proprietor_OfAttornyDocumentBO.date==''||OnboardClientDocumentBO?.individual_Sole_Proprietor_OfAttornyDocumentBO.date==undefined||OnboardClientDocumentBO?.individual_Sole_Proprietor_OfAttornyDocumentBO.date==null || Partisign==null || Partisign==''||Partisign==undefined"  class="btn blue-btn"
                           >Save</button>
                          <button type="button" class="btn blue-btn" *ngIf="isUpdate && !clientonboardBO.edit">Update
                          
                          </button>
                          <button type="button" class="btn blue-btn ml-3" data-bs-dismiss="modal">Clear</button>
                        </div> -->

                      </div>
                    </div>
                  </div>
                </div>



              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </kendo-pdf-export>
</div>



<!-- ///////////////// NOTES ///////////////////////// -->

<span id="openOfficeNotes" data-bs-toggle="modal" data-bs-target="#modalofficeNotes"></span>
<div class="modal hide fade modalbackgrod" id="modalofficeNotes" tabindex="-1" aria-labelledby="exampleModalLabel"
  aria-hidden="true" data-backdrop="static">
  <div class="modal-dialog  ">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title font-header" id="exampleModalLabel">Office Notes</h5>
        <button type="button" class="btn-close" data-bs-dismiss="modal" (click)="clearFields()"></button>
      </div>
      <div class="modal-body ">
        <div class="row">
          <div class="col-lg-4">
            <label class="mt-4">Notes<sup class="super-script mr-1 ">*</sup></label>
          </div>
          <div class="col-lg-6">
            <textarea class="form-control" style="width: 249px;height: 72px;" [(ngModel)]="OfficeNotesBO.officenotes">
            </textarea>
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <button class="btn blue-btn btn-sm" (click)="OfficeNotes()" [disabled]="OfficeNotesBO.officenotes==null||
        OfficeNotesBO.officenotes==undefined || OfficeNotesBO.officenotes==''|| disabledNotes"><span>Save</span>
        </button>
        <button type="button" class="btn blue-btn btn-sm" data-bs-dismiss="modal" (click)="clearFields()">Close</button>
      </div>
    </div>
  </div>
</div>


<!-- //////////////////// TEMPLATE NAME CHOOSE ///////////////////////// -->

<span id="templateNameModal" data-bs-toggle="modal" data-bs-target="#templateModal"></span>
<div class="modal fade modalbackgrod" id="templateModal" tabindex="-1" aria-labelledby="templateModalLabel"
  aria-hidden="true" data-bs-backdrop="false">
  <div class="modal-dialog mt-5 pt-5" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title font-header" id="templateModalLabel">Template</h5>
        <button type="button" class="btn-close" data-bs-dismiss="modal"></button>
      </div>
      <div class="modal-body">
        <div class="row">
          <div class="col-lg-4">
            <label class="">Template Name</label>
          </div>
          <div class="col-lg-6">
            <ng-select class="w" [items]="documentlist" [searchable]="true" [(ngModel)]="templatename"
              [clearable]="true" bindLabel="templateName" bindValue="id" (ngModelChange)="GetTemplateNameList()">
            </ng-select>
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-sm" (click)="GoTODocument()">Go</button>
        <button type="button" class="btn  btn-sm" data-bs-dismiss="modal">Close</button>
      </div>
    </div>
  </div>
</div>

<span id="openClientAggrdelete" data-bs-toggle="modal" data-bs-target="#modalDeleteClientAggrement"></span>
<div class="modal hide modalbackgrod" id="modalDeleteClientAggrement" tabindex="-1"
  aria-labelledby="modalofficeNotesLabel" aria-hidden="true" data-bs-backdrop="false">
  <div class="modal-dialog modal-sm">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title font-header" id="exampleModalLabel">
          <span>Delete </span>
        </h5>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close">

        </button>
      </div>
      <div class="modal-body">
        Are you sure you want to Delete?
      </div>
      <div class="modal-footer">
        <button type="button" class="btn blue-btn btn-sm" (click)="Delete()">Yes</button>
        <button type="button" class="btn blue-btn btn-sm" data-bs-dismiss="modal">No</button>
      </div>
    </div>
  </div>
</div>